export const destinations = [
  {
    id: 1,
    image: '/images/destination/Heritage_Jharkhand.png',
    title: 'Heritage Jharkhand',
    desc1: 'Explore the breathtaking and intricate architectural marvels along with the iconic and historically significant landmarks that vividly reflect Jharkhand’s rich, diverse, and glorious past spanning centuries.',
    desc2: 'Embark on a captivating journey through the heart of Jharkhand’s fascinating heritage, where ancient ruins stand as silent witnesses to bygone eras, majestic colonial-era structures showcase the influence of foreign powers, and centuries-old temples reveal the spiritual and artistic brilliance of the region. Delve deep into a timeless exploration of the state’s unique cultural and architectural legacy, discovering the stories, craftsmanship, and traditions that have shaped Jharkhand’s identity. Whether you are drawn to the exquisite carvings, monumental architecture, or the historical narratives embedded within each site, Jharkhand promises an enriching and unforgettable experience that connects the past with the present in the most vivid way possible.',
    data: [
      {
        title: "Palamu Fort",
        description: [
          `The twin Palamu Forts, nestled in the dense forests of Betla National Park in Jharkhand, are a striking testament to the Chero dynasty's architectural prowess and the region's turbulent history. Built in the 17th century, the forts comprise the Old Fort (Purana Qila) and the New Fort (Naya Qila), both overlooking the Auranga River (also called the "fanged river" due to its jagged rock formations). The ruins, with their 7-foot-thick walls, intricate Nagpuri Gate carvings, and remnants of Hindu temples-turned-mosques, offer a hauntingly beautiful glimpse into the past. The site is ideal for photography, with panoramic views of the surrounding forests and hills, while the rugged terrain invites light trekking and nature walks.`
        ],
        history: [
          `The Old Fort was originally constructed by the Raksel dynasty and later fortified by Chero king Medini Rai (1658–1674), who also built the New Fort on a nearby hill. The forts witnessed Mughal invasions under Daud Khan, who destroyed temples and imposed Islamic rule, and later British colonial sieges in 1771. The New Fort's Nagpuri Gate, adorned with Persian-style arabesque designs, stands as a symbol of the Cheros' cultural synthesis. After centuries of neglect, the Jharkhand government has initiated restoration efforts to preserve this 400-year-old legacy.`
        ],
        bestTimeToVisit: [
          `The ideal time is October to March, when the weather is cool (10–25°C) and the surrounding Betla National Park teems with wildlife. Avoid the monsoon (July–September) due to slippery trails and the summer heat (April–June), which can exceed 40°C.`
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Palamu Fort is well-connected by road networks. The nearest major town is Daltonganj, located about 25 km away. Ranchi, the capital of Jharkhand, is approximately 160 km from the fort. Regular buses and taxis are available from these locations to reach the fort.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Daltonganj Railway Station, about 25 km from Palamu Fort. It is connected to major cities like Ranchi, Patna and Kolkata. From the station, visitors can hire taxis or take local buses to reach the fort.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The closest airport is Birsa Munda Airport in Ranchi, located about 160 km from Palamu Fort. Regular flights connect Ranchi to major Indian cities like Delhi, Kolkata and Mumbai. From the airport, visitors can hire taxis or take buses to reach the fort.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/PalamuFort1.webp",
          "/images/destination/PalamuFort2.webp",
          "/images/destination/PalamuFort3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Nawratan_gadh1.webp", alt: "Navratangarh Fort" },
          { img: "/images/destination/IskoCave1.webp", alt: "Isko Cave" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]
      },
      {
        title: "Navratangarh Fort",
        description: [
          `The imposing ruins of Navratangarh Fort stand as a remarkable example of Nagvanshi dynasty architecture in Jharkhand. This five-storeyed palace complex features a unique "water-gate" entrance and protective moat (garh-khai), rare defensive structures among Jharkhand's forts. Visitors can explore the remains of the royal court (darbar), treasury, and dungeon prison, while admiring the intricate stonework. The adjacent Kapilnath Temple, built in 1643 CE, showcases beautiful Nagvanshi-era carvings. The fort's crumbling walls and arches, now partially reclaimed by nature, create a melancholic yet photogenic atmosphere, especially during sunrise and sunset when the golden light enhances the ancient stonework.`
        ],
        history: [
          `Navratangarh Fort was established as a new capital by King Durjan Shah after his return from Mughal captivity (1636–1639 CE). The fort's design reflects both indigenous and Mughal influences, likely inspired by the king's experiences during imprisonment. The complex's innovative water-gate and moat system demonstrate advanced military architecture for its time. The Kapilnath Temple within the complex was commissioned by King Ram Shah in 1643 CE. Though now in ruins, the site remains an important archaeological record of the region's medieval history and the Nagvanshi dynasty's architectural achievements.`
        ],
        bestTimeToVisit: [
          `The best period to visit is between October and March when temperatures are pleasant (15–28°C). Early morning and late afternoon visits are recommended for optimal lighting and comfortable exploration. The monsoon season (July–September) is less ideal due to slippery pathways and overgrown vegetation.`
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Navratangarh Fort is located about 70 km from Ranchi. The nearest town is Sisai, approximately 15 km away. Regular buses and taxis are available from Ranchi, with the journey taking about 2 hours via NH33 and state highways.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Ranchi Junction, about 75 km from the fort. It has good connections to major Indian cities. From Ranchi, visitors can hire taxis or take local transport to reach the site.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport in Ranchi (approximately 80 km away) is the closest airport, with regular flights to Delhi, Kolkata, Mumbai and other major cities. Taxis are available at the airport for the 2-hour drive to the fort.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Nawratan_gadh1.webp",
          "/images/destination/Nawratan_gadh2.webp",
          "/images/destination/Nawratan_gadh3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/PalamuFort1.webp", alt: "Palamu Fort" },
          { img: "/images/destination/IskoCave1.webp", alt: "Isko Cave" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]
      },
      {
        title: "Gangaghat, Rajmahal",
        description: [
          "Gangaghat is a redeveloped riverside promenade on the banks of the Ganges in Rajmahal, Sahibganj district.",
          "It combines community spaces, terraces, and green design, making it both functional and scenic.",
          "The site reflects environmental restoration and cultural identity linked to the Ganga."
        ],
        history: [
          "Rajmahal Ghat redevelopment tied cultural revival with ecological restoration.",
          "It provides modern access to the sacred Ganga in a scenic setting framed by rustic hills."
        ],
        bestTimeToVisit: [
          "Dry seasons are best, as monsoon swells the river and muddies the terraces.",
          "Visit when water levels are manageable and paths safe."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Rajmahal connects via NH-33 from Sahibganj, though road quality is mixed with potholes reported.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Rajmahal Railway Station on Sahibganj loop is the nearest stop. From there, the ghat is a short ride or walk.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airport is Ranchi. From there, onward travel is by road or train to Rajmahal.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Heritage/GangaghatRajmahal1.jpg",
          "/images/destination/Heritage/GangaghatRajmahal2.jpg",
          "/images/destination/Heritage/GangaghatRajmahal3.jpg",
          "/images/destination/Heritage/GangaghatRajmahal4.jpg"
        ],
        nearbyAttractions: [
          { img: "/images/destination/PalamuFort1.webp", alt: "Palamu Fort" },
          { img: "/images/destination/IskoCave1.webp", alt: "Isko Cave" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]
      },
      {
        title: "Sahid Park, Kharsawan",
        description: [
          "Sahid Park in Kharsawan town is a memorial site honouring the victims of the 1948 Kharsawan Firing.",
          "It stands as a symbol of sacrifice, courage, and resistance in Jharkhand’s history.",
          "Visitors experience both historical reflection and cultural performances here."
        ],
        history: [
          "On 1st January 1948, police fired on unarmed protestors demanding Kharsawan’s inclusion in Odisha, killing many.",
          "The park now serves as a memorial where annual tributes and cultural events are held.",
          "Schools bring students to learn about this important local history."
        ],
        bestTimeToVisit: [
          "1st January: Annual martyrdom day is most significant with ceremonies and performances.",
          "November to February: Pleasant winter weather for visiting the park."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Kharsawan is about 55 km from Jamshedpur and 25 km from Saraikela, connected by buses and taxis.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Sini Railway Station (30 km away) has trains to Jamshedpur, Ranchi, and other towns.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport, Ranchi (130 km away) is the nearest. From Ranchi, taxis and buses connect via Saraikela.",
            icon: "/images/destination/plane.png"
          }
        ],
          images: [
          "/images/destination/Heritage/ShahidParkSaraikela1.jpg",
          "/images/destination/Heritage/ShahidParkSaraikela2.jpg",
          "/images/destination/Heritage/ShahidParkSaraikela3.jpg",
          "/images/destination/Heritage/ShahidParkSaraikela4.jpg"
        ],
        nearbyAttractions: [
          { img: "/images/destination/PalamuFort1.webp", alt: "Palamu Fort" },
          { img: "/images/destination/IskoCave1.webp", alt: "Isko Cave" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]
      },
      {
        title: "Bhim Chulha, Mohammadganj",
        description: [
          "Bhim Chulha is a unique rock formation on the banks of the North Koel River in Mohammadganj, Palamu.",
          "It is believed to be the stove used by Bhima of the Pandavas during their exile.",
          "The site blends mythology, spirituality, and natural heritage with temples and fairs."
        ],
        history: [
          "Legends say the Pandavas used Bhim Chulha to cook food in exile.",
          "Carved footprints of the Pandavas and Kunti are preserved nearby.",
          "Fairs and rituals during Makar Sankranti and New Year celebrations keep traditions alive."
        ],
        bestTimeToVisit: [
          "New Year’s Eve and Makar Sankranti: Festive atmosphere with rituals and fairs.",
          "December to February: Cool winter weather, perfect for sightseeing.",
          "Off-season months: Quiet and ideal for reflection."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Bhim Chulha is 30 km from Hussainabad and 95 km from Medininagar, accessible by scenic rural roads.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Mohammadganj Railway Station is just 3 km away with regular connections to Palamu and nearby districts.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Ranchi Airport is about 230–250 km away. Travel continues by road or rail to Mohammadganj.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Heritage/BhimChulhaPalamu1.jpg",
          "/images/destination/Heritage/BhimChulhaPalamu2.jpg",
          "/images/destination/Heritage/BhimChulhaPalamu3.jpg",
          "/images/destination/Heritage/BhimChulhaPalamu4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Heritage/MartelloTowerPakur1.jpg", alt: "Martello Tower, Pakur" },
          { img: "/images/destination/IskoCave1.webp", alt: "Isko Cave" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]

      },
      {
        title: "Martello Tower, Pakur",
        description: [
          "Martello Tower in Pakur, built in 1856 by the British, is a historic defensive structure.",
          "It was constructed to oversee the region during the Santhal rebellion.",
          "Located in Sidho Kanho Murmu Park, it remains a rare inland Martello tower."
        ],
        history: [
          "Built by Sir Martin, a British officer, to suppress Santhal resistance.",
          "Its vantage point allowed surveillance across Pakur’s hills and plains.",
          "For locals, it symbolizes both colonial oppression and survival."
        ],
        bestTimeToVisit: [
          "Daytime visits are best for visibility.",
          "The site is not well-maintained, but its history and mystique attract visitors."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "The tower is near Sidho Kanho Murmu Park, close to the DC’s office in Pakur. A short walk from the bus stand.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Pakur Railway Station on Sahibganj Loop is the nearest railhead, with easy access to the site.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Nearest major airport is Ranchi, from where onward travel is by rail or road to Pakur.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Heritage/MartelloTowerPakur1.jpg",
          "/images/destination/Heritage/MartelloTowerPakur2.jpg",
          "/images/destination/Heritage/MartelloTowerPakur3.jpg",
          "/images/destination/Heritage/MartelloTowerPakur4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/PalamuFort1.webp", alt: "Palamu Fort" },
          { img: "/images/destination/Heritage/BhimChulhaPalamu1.jpg", alt: "Bhim Chulha, Mohammadganj" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]

      },

      {
        title: "Isko Cave",
        description: [
          `Isco Cave is a remarkable prehistoric site in Jharkhand, known for its Mesolithic-era rock paintings dating back to 9000–5000 BCE. The cave features stunning ochre and white pigment artworks depicting animals, human figures, and ritual scenes. Among its most famous paintings are the "dancing human figures" and ancient handprints, which provide a fascinating link between prehistoric and modern tribal art traditions. The natural sandstone shelters served as dwellings for early human communities, offering a rare glimpse into their lives.`,
          `Visitors can observe the striking similarities between these ancient paintings and the contemporary Sohrai and Khovar murals created by local tribes, showcasing an unbroken artistic legacy spanning thousands of years.`
        ],
        history: [
          `The cave's rock art represents some of the earliest known human artistic expressions in eastern India. Created by hunter-gatherer communities during the Mesolithic period, these paintings document their daily lives, spiritual beliefs, and connection with nature.`,
          `The recurring motifs of animals, hunting scenes, and ritual dances suggest these caves were not just shelters but also sacred spaces. Archaeologists have noted the site's significance in understanding the transition from prehistoric to tribal art forms, as many symbols and styles seen in the cave continue to appear in the traditional art of local indigenous communities today.`
        ],
        bestTimeToVisit: [
          `The ideal time to visit Isco Cave is from October to March, when the weather is cool and dry (15–28°C). Early morning or late afternoon visits provide the best lighting for viewing the paintings.`,
          `The monsoon season (July–September) should be avoided due to slippery paths and potential flooding in the cave area.`
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Isco Cave is located near the village of Isco, approximately 40 km from Hazaribagh. The cave is accessible via state highways, and taxis or local buses can be taken from Hazaribagh. The journey takes about 1.5 hours.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Barkakana, about 45 km from the cave. It is connected to major cities like Ranchi, Patna, and Kolkata. From the station, visitors can hire taxis or take local transport to reach the site.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The closest airport is Birsa Munda Airport in Ranchi, located about 70 km from Isco Cave. Regular flights connect Ranchi to Delhi, Kolkata, and Mumbai. Taxis are available at the airport for the 3-hour drive to the cave.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/IskoCave1.webp",
          "/images/destination/IskoCave2.webp",
          "/images/destination/IskoCave3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Nawratan_gadh1.webp", alt: "Navratangarh Fort" },
          { img: "/images/destination/PalamuFort1.webp", alt: "Palamu Fort" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]
      },
      {
        title: "Itkhori Temple",
        description: [
          `The Itkhori Temple Complex in Jharkhand's Chatra district is a remarkable confluence of Hinduism, Buddhism, and Jainism, standing as a testament to India's syncretic spiritual heritage.`,
          `At its heart lies the 9th-century Bhadrakali Temple, housing a 5-foot black stone idol of Goddess Bhadrakali (worshipped by Buddhists as Tara) with intricate carvings and a Brahmi inscription dating to King Mahendra Pal's reign.`,
          `The complex features a unique Sahastra Shivling - a central Shivalinga surrounded by 1,008 miniature lingas carved into temple walls, believed to grant the merit of worshipping all simultaneously.`,
          `Jain devotees revere the site for the charan paduka (footprint) of the 10th Tirthankar Shitalnath, marking his birthplace, locally called "Bhaduli Mata Temple".`,
          `Archaeological excavations have revealed Buddhist stupas with 1,008 Buddha figurines and medieval sculptures, blending artistic styles across faiths.`
        ],
        history: [
          `The temple's origins trace to the 7th–10th century CE under the Pala dynasty, with evidence suggesting it was built atop an earlier Buddhist stupa.`,
          `Local legend states Gautama Buddha meditated here during his journey to Bodh Gaya, prompting his aunt's lament "Iti khoi" ("I lost him here")—giving the village its name.`,
          `The site flourished as a religious hub during the Gupta and Pala periods, evidenced by Buddhist relics (200 BCE–1200 CE) and Jain artifacts linking it to Tirthankar Shitalnath.`,
          `ASI excavations (2011–13) uncovered stupa ruins, sculpted panels of Buddha in various mudras, and temple fragments confirming its tri-religious significance.`,
          `Despite Hindu predominance today, the temple's architecture preserves its multicultural past, with black stone icons of Bhadrakali, Shiva, Hanuman, Buddha, and Jain Tirthankars displaying stylistic unity.`
        ],
        bestTimeToVisit: [
          `October to March offers pleasant weather (15–28°C) ideal for exploration.`,
          `Avoid monsoons (July–September) due to slippery paths.`,
          `Maha Shivratri (Feb–Mar) and Shravan month (Jul–Aug) attract thousands for special rituals at the Sahastra Shivling.`
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Itkhori is 150km from Ranchi via NH20/NH33, 63km from Hazaribagh, and 35km from Chatra district HQ. Regular buses and taxis operate from these cities.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest major station is Hazaribagh Road (55km away), connected to Ranchi, Patna, and Kolkata. From here, hire taxis or take local transport.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport in Ranchi (160km away) has flights from Delhi, Kolkata, and Mumbai. Taxis are available for the 3.5-hour drive.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Itkhori1.webp",
          "/images/destination/Itkhori2.webp",
          "/images/destination/Itkhori3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/PalamuFort1.webp", alt: "Palamu Fort" },
          { img: "/images/destination/Nawratan_gadh1.webp", alt: "Navratangarh Fort" },
          { img: "/images/destination/IskoCave1.webp", alt: "Isko Cave" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]
      },
      {
        title: "Maluti Temples",
        description: [
          `The Maluti Temples, nestled in the quiet village of Maluti in Jharkhand’s Dumka district, are a breathtaking cluster of 72+ terracotta temples, originally numbering 108.`,
          `Built between the 17th and 19th centuries by competing branches of the Baj Basanta dynasty, these temples showcase intricate terracotta carvings depicting scenes from Hindu epics like the Ramayana and Mahabharata, royal life, and delicate floral motifs.`,
          `The temples, many named after women, reflect a unique blend of Bengali architectural styles, primarily the ‘char-chala’ (four-sloped roof) and ‘rekha deul’ (curvilinear spire) designs.`,
          `The site also includes the revered Mauliksha Temple, where the famous Bengali mystic Sadhak Bamakhyapa attained his first spiritual awakening.`,
          `Surrounded by serene village life and the flowing Chila River, Maluti offers a rare glimpse into India’s syncretic religious and artistic heritage.`
        ],
        history: [
          `Maluti’s history traces back to the 15th century when Sultan Alauddin Husain Shah of Gaura granted the "Nankar Raj" (tax-free kingdom) to a Brahmin named Basanta for saving his pet hawk.`,
          `Basanta, later known as Raja Baj Basanta, and his descendants built temples instead of palaces, leading to a competitive temple-building spree among four family branches.`,
          `The village, once known as Gupta Kashi, was a center of Vedic learning and hosted an Ashvamedha Yajna during the Shunga dynasty (185 BCE).`,
          `Adi Shankaracharya is said to have challenged Buddhism here during his travels.`,
          `Over time, neglect and environmental decay threatened the temples until conservation efforts by the Global Heritage Fund and ASI began in the 21st century.`
        ],
        bestTimeToVisit: [
          `The ideal time to visit is from October to March, when temperatures range between 15–28°C, making exploration comfortable.`,
          `Avoid the monsoon (July–September) due to slippery paths and the scorching summer (April–June), which can exceed 40°C.`,
          `Kali Puja (October–November) is a vibrant festival here, though the animal sacrifices may unsettle some visitors.`
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Maluti is 55 km from Dumka Regular buses and taxis operate from both towns. The village is accessible via NH114A, with the last stretch requiring a short walk or local transport.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Dumka (60 km away), well-connected to Kolkata via trains like Ganadevta Express and Maa Tara Express. From Dumka, hire a taxi or take a bus to Maluti.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The closest airport is Deoghar Airport in Deoghar (128 km) or Birsa Munda Airport in Ranchi (323 km). Taxis are available from both airports for the 3–4 hour drive.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Maluti1.webp",
          "/images/destination/Maluti2.webp",
          "/images/destination/Maluti3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/PalamuFort1.webp", alt: "Palamu Fort" },
          { img: "/images/destination/Nawratan_gadh1.webp", alt: "Navratangarh Fort" },
          { img: "/images/destination/IskoCave1.webp", alt: "Isko Cave" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" }
        ]
      },
      {
        title: "Pampapur",
        description: [
          "Pampapur is a small village located in the Palkot block of Gumla district, Jharkhand. The area is surrounded by rolling hills, dense forests, and small streams, creating a tranquil rural setting that feels far removed from urban life. Palkot itself is historically and culturally significant, as it served as a seat of regional rulers in earlier centuries, and Pampapur village lies close to the foothills where remnants of ancient settlements can still be found.Visitors to Pampapur experience a unique blend of nature and rural culture.The village offers scenic views of terraced fields, forested hills, and occasional grazing livestock, providing a peaceful environment for photography, walks, and quiet reflection.The region is sparsely populated, so visitors can enjoy a sense of solitude while exploring local traditions and village life.Pampapur also serves as a gateway for those who wish to explore the nearby Palkot fort ruins and other historical sites, making it an interesting stop for cultural and historical enthusiasts."
        ],
        history: [
          "The primary significance of Pampapur lies in its historical and cultural connection to the Palkot region. Palkot has been known as a centre of local power, and nearby ruins suggest the presence of forts, old dwellings, and defensive structures that date back several centuries. Pampapur village itself retains traditional Jharkhandi rural architecture, with mud-and-thatch houses, local temples, and community gathering spaces that reflect the enduring lifestyle of the region.Local festivals, such as Sarhul and Karma, are celebrated with songs, dances, and community gatherings, allowing visitors to witness living traditions that have survived through generations. These festivals often take place in the open village squares or near small temples, offering a glimpse into how religion, culture, and community are interwoven in rural Jharkhand. The village’s quiet lanes, open fields, and the surrounding natural beauty enhance the cultural experience, giving a sense of continuity with the past."
        ],
        bestTimeToVisit: [
          "The best time to visit Pampapur is from October to March, when the weather is mild and dry. During these months, the climate is pleasant for walking, exploring the village, and photographing the scenic surroundings. Summers from April to June can be hot, making outdoor activities uncomfortable, while monsoon rains from July to September can make rural paths muddy and difficult to navigate. Visiting in the cooler months also allows tourists to experience local festivals and traditional practices in a comfortable environment."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Pampapur is located approximately 25 kilometres from Gumla town, the district headquarters. Roads are mostly rural but accessible, and local buses or shared vehicles can be hired from Gumla to reach the village. Private vehicles are recommended for easier access and flexibility.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Gumla Railway Station, around 25 kilometres from Pampapur. From there, visitors can hire taxis or shared autos to reach the village.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "TThe closest airport is Birsa Munda Airport in Ranchi, located approximately 130 kilometres from Pampapur. From Ranchi, visitors need to travel by road to Gumla and then continue to Pampapur village.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Pampapur/Pampapur_Gumla_1.jpg",
          "/images/destination/Pampapur/Pampapur_Gumla_2.jpg",
          "/images/destination/Pampapur/Pampapur_Gumla_3.jpg",
          "/images/destination/Pampapur/Pampapur_Gumla_4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Nawratan_gadh1.webp", alt: "Navratangarh Fort" },
          { img: "/images/destination/IskoCave1.webp", alt: "Isko Cave" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]
      },
      {
        title: "Padma Kila",
        description: [
          "Padma Kila is a historic fort situated near the town of Hazaribagh in Jharkhand. Nestled on a small hillock, the fort overlooks the surrounding plains, providing a panoramic view of the landscape. The fort is relatively modest in size, but its stone walls, remnants of watchtowers, and old gateways convey the strength and planning of its builders. Unlike large and heavily restored forts, Padma Kila retains a quiet, understated charm that appeals to history enthusiasts and casual visitors alike. The fort is surrounded by patches of dry forest, open grasslands, and rocky paths that lead visitors through the area. Walking along these trails offers glimpses of local flora and occasional sightings of small wildlife, making it a rewarding site for those interested in nature as well as history.Local residents and travelers often describe Padma Kila as a peaceful spot, ideal for exploring the fort ruins, enjoying a picnic, or simply watching the sun set over Hazaribagh’s hills. The fort is not only a historic monument but also a part of the cultural memory of the town, representing the legacy of local rulers who once controlled the region. Its elevated position and surrounding open land give a sense of isolation, allowing visitors to experience a calm atmosphere without the crowds that visit more prominent tourist sites."
        ],
        history: [
          "The significance of Padma Kila lies primarily in its architecture. The fort’s walls are constructed with locally sourced stone, and though parts have crumbled over time, the remaining structures reflect traditional defensive design. The entrance gateways, though weathered, are still recognizable and provide a sense of the fort’s scale. Small watchtowers at strategic points on the walls suggest that the fort was built for both defence and surveillance of the surrounding area.Within the fort, the layout includes courtyards and enclosed spaces that would have served administrative and residential purposes. The use of stone masonry without mortar in certain areas shows local construction techniques of the period. Visitors can also observe carved details on some walls and entrances, hinting at the aesthetic considerations of the fort’s builders. While it is smaller than many famous forts, Padma Kila offers a clear view of regional fort architecture and provides insight into how smaller local rulers fortified their territories."
        ],
        bestTimeToVisit: [
          "The ideal time to visit Padma Kila is from October to March. During these months, the weather remains cool and pleasant, making walking around the fort more comfortable. Summers can be hot and uncomfortable, and the monsoon season can make paths slippery and unsafe. Early mornings or late afternoons are particularly good times to visit, as the light enhances the views from the hilltop and adds a calm, peaceful quality to the experience."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Padma Kila is located about 6 kilometres from Hazaribagh town, the district headquarters. The roads are generally in good condition, and taxis, private vehicles, or local buses can reach the fort easily.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Hazaribagh Road, situated approximately 30 kilometres from the fort. From the station, visitors can hire taxis or share local transport to reach Padma Kila.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The closest airport is Birsa Munda Airport in Ranchi, around 150 kilometres away. Visitors can travel by road from Ranchi to Hazaribagh and then reach the fort via local transport.",
            icon: "/images/destination/plane.png"
          },

        ],
        images: [
          "/images/destination/PadmaKila/PadmaKilaHazaribagh1.jpg",
          "/images/destination/PadmaKila/PadmaKilaHazaribagh2.jpg",
          "/images/destination/PadmaKila/PadmaKilaHazaribagh3.jpg",
          "/images/destination/PadmaKila/PadmaKilaHazaribagh4.jpg"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Nawratan_gadh1.webp", alt: "Navratangarh Fort" },
          { img: "/images/destination/IskoCave1.webp", alt: "Isko Cave" },
          { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
          { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
        ]

      },
      // {
      //   title: "Isko Guffa",
      //   description: [
      //     "Isko Guffa, located in Barkagaon block of Hazaribagh district, is one of Jharkhand’s most significant prehistoric rock art sites. The cave, also known as the Isko Rock Shelter, contains paintings that date back to the Mesolithic and Chalcolithic periods (roughly 9000–5000 years ago). These paintings showcase hunting scenes, animals, humans, and symbolic figures drawn with natural pigments.What makes Isko unique is that it connects modern visitors to the earliest human creativity and expression in the region. It’s not just a cave but an ancient “open-air gallery” where tribal ancestors left behind their imagination and lifestyle on stone walls. Unlike monuments built in historical periods, Isko speaks of prehistory of people who lived without written records but expressed themselves through art. Researchers see this site as one of the most important cultural windows into the ancient human past of Jharkhand."
      //   ],
      //   history: [
      //     "For the local tribal communities, especially the Asur and Birhor tribes, Isko is not merely an archaeological site but a sacred place. They see the cave and its rock art as a direct link to their ancestors. Some paintings are believed to depict spirits, rituals, or mythological events. Oral traditions describe the cave as a dwelling place of ancient beings and spiritual forces. This blending of archaeology and living tribal belief makes Isko stand apart from many other rock art shelters in India. The cave lies amidst the scenic landscape of Hazaribagh’s hills, surrounded by forests, streams, and rugged terrain. The walls of the cave are smooth and large enough to serve as a canvas, where red and white pigments were used for painting."
      //   ],
      //   bestTimeToVisit: [
      //     "Winter (October–February): Comfortable weather and easier exploration of the cave and nearby hills.Monsoon (July–September): Lush green surroundings, though accessibility may be difficult due to rains.Summer (March–June): Hot, but mornings and evenings are manageable."
      //   ],
      //   howToReach: [
      //     {
      //       label: "By Road",
      //       detail: "Isko Guffa is around 46 km from Hazaribagh town. Local roads connect it to Barkagaon block. Private cars or hired cabs are the best option.",
      //       icon: "/images/destination/bus.png"
      //     },
      //     {
      //       label: "By Train",
      //       detail: "The nearest major railway station is Hazaribagh Road (Koderma line). From there, road transport is required.",
      //       icon: "/images/destination/train.png"
      //     },
      //     {
      //       label: "By Air",
      //       detail: "The nearest airport is Birsa Munda Airport, Ranchi, about 100 km away.",
      //       icon: "/images/destination/plane.png"
      //     }
      //   ],
      //   images: [
      //     "/images/destination/IskoCave/IscoCaveHazaribagh1.jpg",
      //     "/images/destination/IskoCave/IscoCaveHazaribagh2.jpg",
      //     "/images/destination/IskoCave/IscoCaveHazaribagh3.jpg",
      //     "/images/destination/IskoCave/IscoCaveHazaribagh4.jpg"
      //   ],
      //   nearbyAttractions: [
      //     { img: "/images/destination/Nawratan_gadh1.webp", alt: "Navratangarh Fort" },
      //     { img: "/images/destination/PadmaKila/PadmaKilaHazaribagh1.jpg", alt: "Padma Kila" },
      //     { img: "/images/destination/Itkhori1.webp", alt: "Itkhori Temple" },
      //     { img: "/images/destination/Maluti1.webp", alt: "Maluti Temples" }
      //   ]

      // }

    ],
  },
  {
    id: 2,
    image: '/images/destination/Eco_Tourism.png',
    title: 'Eco Tourism',
    desc1: 'Immerse yourself in the lush, dense green forests, picturesque hill stations, and the diverse, thriving wildlife that together create the captivating natural landscape of Jharkhand.',
    desc2: 'Discover some of Jharkhand’s most enchanting natural havens such as the tranquil and scenic hill station of Netarhat, the expansive and biodiverse Betla National Park, and the serene Dalma Wildlife Sanctuary. These eco-friendly destinations provide memorable adventures, rich biodiversity, and peaceful escapes into pristine, untouched nature, making them perfect for nature lovers, adventurers, and wildlife enthusiasts seeking authentic experiences.',
    data: [
      {
        title: "Lodh Waterfall",
        description: [
          "Lodh Falls, also known as Budha Ghagh, is the highest waterfall in Jharkhand and the 21st highest in India, cascading dramatically from a height of 143 meters (469 feet) in multiple tiers.",
          "Located deep within the Palamau Tiger Reserve on the Burha River, this natural wonder is surrounded by dense sal forests teeming with wildlife.",
          "The thunderous roar of the falls can be heard from up to 10 km away, creating an awe-inspiring experience of nature’s raw power.",
          "The misty sprays and golden sunlight filtering through the forest canopy make it a paradise for photographers.",
          "Local tribal guides often share fascinating folklore about the falls, adding a cultural dimension to the visit."
        ],
        history: [
          "Lodh Falls is a classic example of a 'knickpoint' waterfall, formed by geological rejuvenation that created a sudden break in the river’s gradient.",
          "The site has long been revered by local tribal communities, who consider it sacred.",
          "While not much documented historical significance is attached to the falls, its isolation within the Palamau Tiger Reserve has preserved its pristine beauty.",
          "Recent efforts by the Jharkhand Forest and Tourism Department, including the installation of safety chains (163 feet long) in 2021, have made it more accessible to tourists while ensuring conservation."
        ],
        bestTimeToVisit: [
          "The ideal time to visit is October to March, when the weather is cool (10–25°C) and the water flow is robust yet safe for trekking.",
          "Avoid the monsoon (July–September) due to slippery trails and the summer (April–June), which brings scorching heat (up to 40°C).",
          "Early mornings offer the best lighting for photography and wildlife sightings."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Lodh Falls is approximately 105 km from Latehar and 198 km from Ranchi. The nearest major town is Netarhat (55 km away). Taxis and buses operate from Ranchi and Latehar, with the final stretch requiring a forest trek.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The closest railway station is Latehar Railway Station (100 km away), connected to Ranchi and Patna. From Latehar, hire a taxi or take a local bus to the falls’ entry point.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport in Ranchi (180 km away) is the nearest airport, with flights from Delhi, Kolkata, and Mumbai. Taxis are available for the 4–5 hour drive through scenic routes.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Lodh2.webp",
          "/images/destination/Lodh4.webp",
          "/images/destination/Lodh3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/netarhat.webp", alt: "Netarhat" },
          { img: "/images/destination/dalma1.webp", alt: "Dalma Wildlife Sanctuary" },
          { img: "/images/destination/betla_1.webp", alt: "Betla National Park" },
          { img: "/images/destination/Patratu1.webp", alt: "Patratu Valley" }

        ]
      },

      {
        title: "Netarhat",
        description: [
          "Netarhat, often called the \"Queen of Chotanagpur,\" is a picturesque hill station in Jharkhand's Latehar district, perched at an elevation of 1,071 meters.",
          "Known for its breathtaking viewpoints, the town offers spectacular sunrise views at Sunrise Point overlooking the Koel River valley and mesmerizing sunsets at Magnolia Point, 10 km from the main town.",
          "The surrounding landscape features dense forests, cascading waterfalls like Lower Ghaghri (10 km trek) and Lodh Falls (70 km away), and rich biodiversity.",
          "Netarhat serves as a perfect base for exploring nearby attractions including Betla National Park (64 km), home to tigers, elephants, and ancient Chero dynasty forts.",
          "The cool climate, colonial-era bungalows, and vibrant tribal culture make it a unique retreat."
        ],
        history: [
          "Developed as a hill station during British rule in 1864, Netarhat was originally established as a sanatorium for British officials.",
          "The area holds significance for local tribal communities, particularly the Oraon and Munda tribes, who have inhabited these hills for centuries.",
          "Netarhat's famous Netarhat Residential School, established in 1954, is one of India's oldest and most prestigious boarding schools.",
          "The region's forests were once hunting grounds for royalty and later became part of the Palamau Tiger Reserve, playing a crucial role in Jharkhand's conservation efforts."
        ],
        bestTimeToVisit: [
          "The ideal time to visit is from October to March when temperatures range between 8–25°C, offering pleasant weather for sightseeing.",
          "Winters (December–January) can be chilly, with temperatures dropping to 5°C.",
          "Avoid the monsoon season (July–September) due to slippery roads and limited visibility at viewpoints."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Netarhat is well-connected by road, located 156 km from Ranchi via NH39 and 105 km from Latehar. Regular buses and taxis operate from both cities, with the journey from Ranchi taking approximately 4-5 hours through scenic routes.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Latehar (100 km away), connected to Ranchi and Patna. From Latehar, visitors can hire taxis or take buses to reach Netarhat.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport in Ranchi (160 km away) is the closest airport, with regular flights from major Indian cities. Taxis are available at the airport for the 4-5 hour drive to Netarhat.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/netarhat.webp",
          "/images/destination/Netarhat1.webp",
          "/images/destination/Netarhat3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Lodh2.webp", alt: "Lodh Waterfall" },
          { img: "/images/destination/dalma1.webp", alt: "Dalma Wildlife Sanctuary" },
          { img: "/images/destination/betla_1.webp", alt: "Betla National Park" },
          { img: "/images/destination/Patratu1.webp", alt: "Patratu Valley" }
        ]
      },

      {
        title: "Dalma Wildlife Sanctuary",
        description: [
          "Dalma Wildlife Sanctuary, located just 10 km from Jamshedpur, is a unique ecological treasure in Jharkhand spread across 193 sq km of lush forests.",
          "The sanctuary is famous for its large population of Indian elephants (85+ individuals), best seen between December–January when they return from seasonal migrations to West Bengal.",
          "The diverse landscape of sal, bamboo, and mango forests provides habitat for sloth bears, leopards, pangolins, and occasional tiger sightings (reported in 2024–25).",
          "Birdwatchers can spot exotic species like Indian grey hornbills, peafowls, and crested serpent eagles.",
          "The sanctuary offers a 10-km hiking trail from Dalma Guest House to Makulakocha (requires forest department permission), providing panoramic views of the rich biodiversity."
        ],
        history: [
          "Established in 1975, Dalma was created primarily to protect the migrating elephant population and their corridor between Jharkhand and West Bengal.",
          "The sanctuary sits on the Chota Nagpur Plateau, which has been an elephant habitat for centuries.",
          "During British rule, the area was used for timber until conservation efforts began.",
          "Local tribal communities, particularly the Santhals, have coexisted with these forests for generations, maintaining traditional ecological knowledge.",
          "Recent years have seen increased conservation measures, including anti-poaching camps and habitat restoration projects."
        ],
        bestTimeToVisit: [
          "The ideal visiting period is November to March, when temperatures range between 15–28°C and elephant sightings are most frequent.",
          "Summers (April–June) can be hot (up to 40°C), while monsoons (July–September) make trails inaccessible.",
          "Early mornings (5:30–8:30 AM) offer the best wildlife spotting opportunities."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "The sanctuary is easily accessible from Jamshedpur (30 km via NH33) and Ranchi (90 km via NH43). Regular buses and taxis operate from both cities. The main entry point is at Dalma Guest House.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Tatanagar Junction in Jamshedpur (25 km away) is the nearest major railway station, well-connected to Kolkata, Delhi, and other cities. Auto-rickshaws and taxis are available from the station.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport in Ranchi (100 km away) has regular flights from major cities. Taxis are available from both airports.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/dalma1.webp",
          "/images/destination/dalma2.webp",
          "/images/destination/dalma3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/netarhat.webp", alt: "Netarhat" },
          { img: "/images/destination/Lodh2.webp", alt: "Lodh Waterfall" },
          { img: "/images/destination/betla_1.webp", alt: "Betla National Park" },
          { img: "/images/destination/Patratu1.webp", alt: "Patratu Valley" }
        ]
      },

      {
        title: "Betla National Park",
        description: [
          "Betla National Park, located in Jharkhand's Latehar district, is one of India's first tiger reserves under Project Tiger (1974) and a key part of the Palamau Tiger Reserve.",
          "Spanning 1,026 sq km, it boasts dense sal and bamboo forests, grasslands, and riverine habitats teeming with wildlife.",
          "The park is renowned for its tiger population, along with elephants, leopards, gaurs (Indian bison), and over 200 bird species like hornbills and peafowls.",
          "Unique historical attractions include the 16th-century Chero dynasty forts nestled within the forest.",
          "Visitors can enjoy jeep safaris, elephant rides, and guided nature walks, while watchtowers offer panoramic views of animals congregating near waterholes.",
          "The park's name 'Betla' is an acronym for its iconic fauna: Bison, Elephant, Tiger, Leopard, and Axis deer."
        ],
        history: [
          "The park's origins trace back to 1932 when India's first tiger census was conducted here.",
          "Declared a protected area in 1947, it became Palamau Wildlife Sanctuary in 1973 and a national park in 1986.",
          "The region was historically ruled by the Chero dynasty, whose forts now stand as ruins within the park.",
          "Indigenous tribes like the Oraon and Munda have inhabited these forests for centuries, coexisting with wildlife.",
          "Conservation efforts focus on anti-poaching measures and habitat restoration, though challenges like human-wildlife conflict persist."
        ],
        bestTimeToVisit: [
          "November to April is ideal, with pleasant temperatures (15–28°C) and frequent wildlife sightings.",
          "Summers (May–June) are scorching (up to 40°C) but better for tiger spotting near waterholes.",
          "Monsoons (July–September) are avoided due to park closures and slippery trails."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Betla is 25 km from Daltonganj and 160 km from Ranchi via NH39. Regular buses and taxis operate from both cities.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Daltonganj Railway Station (25 km) and Barwadih Junction (30 km) are the nearest stations, connected to Ranchi, Patna, and Delhi.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport in Ranchi (170 km) is the closest, with flights from major Indian cities. Taxis are available for the 4-hour drive.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/betla_1.webp",
          "/images/destination/betla_2.webp",
          "/images/destination/betla_4.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/netarhat.webp", alt: "Netarhat" },
          { img: "/images/destination/Lodh2.webp", alt: "Lodh Waterfall" },
          { img: "/images/destination/BuddhPahad/BuddhaPahadDeoghar2.jpg", alt: "Budha Pahad, Deoghar Sadar" },
          { img: "/images/destination/Patratu1.webp", alt: "Patratu Valley" }
        ]
      },

      {
        title: "Patratu Valley",
        description: [
          "Patratu Valley, nestled amidst the lush green hills of Jharkhand, is a serene getaway known for its picturesque Patratu Lake and breathtaking landscapes.",
          "The valley offers a perfect blend of tranquility and adventure, with activities ranging from peaceful boating on the lake to thrilling zip-lining and rock climbing.",
          "Visitors can stay at the scenic Patratu Resort, operated by Jharkhand Tourism, which provides comfortable accommodations with stunning views of the surrounding hills and lake.",
          "Nature lovers can enjoy short treks and walks, capturing the valley's beauty through photography, especially during sunrise and sunset.",
          "The lakeside picnic spots make it an ideal destination for families and friends to relax and unwind in nature's lap."
        ],
        history: [
          "Patratu Valley gained prominence due to the construction of the Patratu Dam in the 20th century, which created the beautiful Patratu Lake.",
          "The area was originally inhabited by tribal communities who relied on the region's natural resources.",
          "Over time, the valley's scenic beauty and proximity to Ranchi made it a popular tourist destination.",
          "The Jharkhand Tourism Development Corporation developed the Patratu Resort to promote eco-tourism and provide visitors with a comfortable stay amidst nature."
        ],
        bestTimeToVisit: [
          "The best time to visit Patratu Valley is from October to March when the weather is pleasant (15–25°C), making it ideal for outdoor activities.",
          "Summers (April–June) can be hot, while monsoons (July–September) bring heavy rainfall, which may limit certain activities."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Patratu Valley is located 40 km from Ranchi and is well-connected via NH43. Regular buses and taxis are available from Ranchi, with the journey taking about 1.5 hours.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Ranchi Junction (45 km away), which is well-connected to major cities like Delhi, Kolkata, and Patna. From Ranchi, visitors can hire taxis or take buses to reach Patratu Valley.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport in Ranchi (55 km away) is the nearest airport, with regular flights from major Indian cities. Taxis are available at the airport for the 1.5-hour drive to Patratu Valley.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Patratu1.webp",
          "/images/destination/Patratu2.webp",
          "/images/destination/Patratu3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/netarhat.webp", alt: "Netarhat" },
          { img: "/images/destination/Lodh2.webp", alt: "Lodh Waterfall" },
          { img: "/images/destination/dalma1.webp", alt: "Dalma Wildlife Sanctuary" },
          { img: "/images/destination/betla_1.webp", alt: "Betla National Park" }
        ]
      },
      {
        title: "Budha Pahad, Deoghar Sadar",
        description: [
          "Deoghar, known across India as a spiritual city because of the Baidyanath Dham temple, also carries within it landscapes and sites of quiet natural heritage.",
          "Budha Pahad is a modest hillock close to Deoghar Sadar. The hill, surrounded by scattered trees and open land, is not very high, yet it commands a pleasing view of the countryside.",
          "It is a familiar corner for leisure, picnic, and weekend gatherings, especially for local communities, students, and families."
        ],
        history: [
          "The name Budha Pahad means 'Old Hill' and is woven into the everyday life of Deoghar’s people.",
          "Traditionally, it has been a picnic ground, walking stop, and a place for school trips or casual treks.",
          "Earlier, villagers believed hills like Budha Pahad were abodes of local deities. Seasonal offerings were made to ensure harmony with nature, though this practice has mostly faded."
        ],
        bestTimeToVisit: [
          "November to March: Pleasant winter and early spring weather makes it ideal for picnics and treks.",
          "Summers are hot and dry, less suitable for visits.",
          "Monsoon makes the soil slippery and unsafe for walking.",
          "Festive season of January: Locals prefer visiting during this time as Deoghar is active with fairs."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Budha Pahad is about 15 km from Deoghar Sadar. Local taxis and buses are easily available.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Deoghar Junction (12 km away). Autos and taxis are available from the station.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Deoghar Airport (20 km away) has regular flights from Ranchi, Kolkata, and Patna. Taxis and buses connect the airport to Budha Pahad.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/BuddhPahad/BuddhaPahadDeoghar1.jpg",
          "/images/destination/BuddhPahad/BuddhaPahadDeoghar2.jpg",
          "/images/destination/BuddhPahad/BuddhaPahadDeoghar3.jpg",
          "/images/destination/BuddhPahad/BuddhaPahadDeoghar4.jpg"
        ],
        nearbyAttractions: [
          { img: "/images/destination/netarhat.webp", alt: "Netarhat" },
          { img: "/images/destination/Lodh2.webp", alt: "Lodh Waterfall" },
          { img: "/images/destination/dalma1.webp", alt: "Dalma Wildlife Sanctuary" },
          { img: "/images/destination/Patratu1.webp", alt: "Patratu Valley" }
        ]
      },
      {
        title: "Canary Hills, Hazaribagh",
        description: [
          "Canary Hills is a scenic hill area in Hazaribagh district, surrounded by fields, woodland, and rolling landscapes.",
          "The hills rise moderately above the terrain, offering panoramic countryside views and a tranquil escape from the bustle of Hazaribagh town.",
          "It serves as a popular retreat for families, students, and nature enthusiasts, ideal for photography, meditation, and sunset viewing."
        ],
        history: [
          "Canary Hills is valued for its natural beauty and ecological importance.",
          "The site supports a variety of native plants, seasonal flowers, and wildlife, making it significant for biodiversity.",
          "Locals have long used it for recreation, school trips, and cultural gatherings, embedding it into Hazaribagh’s community identity."
        ],
        bestTimeToVisit: [
          "October to March: Cool and pleasant weather, ideal for trekking and outdoor activities.",
          "Summer months can be hot and humid.",
          "Monsoon season makes trails slippery and less safe."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Canary Hills is about 12 km from Hazaribagh town. Roads are well-maintained, and taxis, private vehicles, or local buses reach the site.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Hazaribagh Town Railway Station is about 15 km away. Local transport or taxis connect the station to Canary Hills.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airport is Birsa Munda Airport, Ranchi (150 km away). From there, taxis or buses reach Hazaribagh and onward to Canary Hills.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/CanaryHill/CanaryHillHazaribagh1.jpg",
          "/images/destination/CanaryHill/CanaryHillHazaribagh2.jpg",
          "/images/destination/CanaryHill/CanaryHillHazaribagh3.jpg",
          "/images/destination/CanaryHill/CanaryHillHazaribagh4.jpg"
        ],
        nearbyAttractions: [
          { img: "/images/destination/BhawarPahad/BhawarPahadSimdega1.jpg", alt: "Bhawar Pahad" },
          { img: "/images/destination/Lodh2.webp", alt: "Lodh Waterfall" },
          { img: "/images/destination/dalma1.webp", alt: "Dalma Wildlife Sanctuary" },
          { img: "/images/destination/Patratu1.webp", alt: "Patratu Valley" }
        ]
      },
      {
        title: "Birsa Mrig Vihar (Birsa Deer Park)",
        description: [
          "Birsa Mrig Vihar, located at Kalamati on the Ranchi–Khunti Road, is a popular 54-acre wildlife park near Ranchi.",
          "It is home mainly to deer species like chital and sambar, living in a natural environment.",
          "The park is a well-known picnic destination for locals and tourists."
        ],
        history: [
          "Surrounded by dense sal forests, the park provides a natural deer habitat.",
          "It contributes to preserving Jharkhand’s biodiversity and bringing people closer to nature.",
          "Watchtowers inside the park allow visitors to observe deer, enhancing the eco-tourism experience."
        ],
        bestTimeToVisit: [
          "October to February: Best season, pleasant weather for sightseeing and deer watching.",
          "March to June: Suitable in mornings and evenings only due to summer heat.",
          "July to September: Lush greenery, but paths can be muddy and slippery."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Birsa Mrig Vihar lies along Ranchi–Khunti highway, about 45 minutes from Ranchi city. Taxis and private vehicles are convenient.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Ranchi Railway Station is the nearest station, about 20 km from the park. Taxis and autos connect to the site.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport, Ranchi (20 km away), is the closest airport. Taxis and rental cars connect to the park.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/BirsaPark/BirsaMrigVihar_Khunti1.jpg",
          "/images/destination/BirsaPark/BirsaMrigVihar_Khunti2.jpg",
          "/images/destination/BirsaPark/BirsaMrigVihar_Khunti3.jpg",
          "/images/destination/BirsaPark/BirsaMrigVihar_Khunti4.jpg"
        ],
        nearbyAttractions: [
          { img: "/images/destination/netarhat.webp", alt: "Netarhat" },
          { img: "/images/destination/Lodh2.webp", alt: "Lodh Waterfall" },
          { img: "/images/destination/dalma1.webp", alt: "Dalma Wildlife Sanctuary" },
          { img: "/images/destination/BhawarPahad/BhawarPahadSimdega1.jpg", alt: "Bhawar Pahad" }
        ]
      },
      {
        title: "Bhawar Pahad",
        description: [
          "Bhawar Pahad in Simdega’s Kolebira block is a natural and historical hill site.",
          "Named after the vast population of black honeybees inhabiting it, the site blends natural beauty with cultural legends.",
          "It features lush forests, high peaks, an ancient temple, and religious events."
        ],
        history: [
          "Local legends say honeybees here were once used like warriors in ancient times.",
          "It hosts the Jagannath Temple, which draws thousands during its annual Rath Yatra.",
          "The hill is home to rare medicinal plants, adding ecological significance."
        ],
        bestTimeToVisit: [
          "June–July: For witnessing the annual Rath Yatra festival.",
          "October–February: Pleasant weather, ideal for trekking and sightseeing.",
          "July–September: Peak greenery, though trekking requires caution."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Accessible from Simdega via Kolebira block. The nearest bus station is in Simdega.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The closest railway station is Rourkela (Odisha), about 100 km from Bhawar Pahad.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airport is in Ranchi, about 160 km away. Taxis and buses connect to Simdega and Bhawar Pahad.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/BhawarPahad/BhawarPahadSimdega1.jpg",
          "/images/destination/BhawarPahad/BhawarPahadSimdega2.jpg",
          "/images/destination/BhawarPahad/BhawarPahadSimdega3.jpg",
          "/images/destination/BhawarPahad/BhawarPahadSimdega4.jpg"
        ],
        nearbyAttractions: [
          { img: "/images/destination/BirsaPark/BirsaMrigVihar_Khunti1.jpg", alt: "Birsa Mrig Vihar (Birsa Deer Park)" },
          { img: "/images/destination/Lodh2.webp", alt: "Lodh Waterfall" },
          { img: "/images/destination/dalma1.webp", alt: "Dalma Wildlife Sanctuary" },
          { img: "/images/destination/Patratu1.webp", alt: "Patratu Valley" }
        ]
      },
      {
        title: "Fossil Park, Sahibganj",
        description: [
          "Fossil Park at Mirza Chowki in Sahibganj district is located in the Rajmahal hills.",
          "It showcases plant fossils aged between 68 to 145 million years, protected under the Jharkhand Forest Department.",
          "The park serves as both an environmental monument and an educational site for researchers and students."
        ],
        history: [
          "Recognized as a national geological monument, Fossil Park bridges natural heritage and scientific study.",
          "The fossils are preserved in rugged Rajmahal hills, where ancient relics are embedded in rocks.",
          "The park is valued as both a scientific attraction and a cultural site for the region."
        ],
        bestTimeToVisit: [
          "Best visited during dry months when paths are safe and visibility is good.",
          "Avoid monsoon due to slippery terrain."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "The park is about 30 km from Sahibganj via the Dumka–Sahibganj road. Local vehicles and private cars are available.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest station is Mirza Chowki Railway Station, 8–10 km away from the park by road.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airports are Ranchi (461 km) and Patna (325 km). From there, road or train connections reach the park.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/FossilPark/FossilParkSahibganj1.jpg",
          "/images/destination/FossilPark/FossilParkSahibganj2.jpg",
          "/images/destination/FossilPark/FossilParkSahibganj3.jpg",
          "/images/destination/FossilPark/FossilParkSahibganj4.jpg"
        ],
        nearbyAttractions: [
          { img: "/images/destination/netarhat.webp", alt: "Netarhat" },
          { img: "/images/destination/BhawarPahad/BhawarPahadSimdega4.jpg", alt: "Bhawar Pahad" },
          { img: "/images/destination/dalma1.webp", alt: "Dalma Wildlife Sanctuary" },
          { img: "/images/destination/Patratu1.webp", alt: "Patratu Valley" }
        ]
      },
      {
        title: "Biodiversity Park,Ranchi",
        description: [
          "Biodiversity Park, established in 2012, lies on the outskirts of Ranchi in Lalkhatanga.",
          "Spread across 542 acres, it contains themed zones showcasing India’s botanical diversity.",
          "The park combines conservation, education, and leisure with spaces like bamboo groves, medicinal gardens, butterfly valley, turtle enclosure, and walking trails."
        ],
        history: [
          "The park preserves rare, medicinal, and indigenous plants, making it a conservation hub.",
          "It is a living classroom promoting ecological awareness for future generations.",
          "Its thematic gardens and biodiversity zones reflect both scientific and cultural botanical traditions."
        ],
        bestTimeToVisit: [
          "October to March: Best season, gardens bloom and weather is cool.",
          "The park is open daily except Mondays, from 10 AM to 5 PM (last entry at 4:30 PM)."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "The park is about 15 km from Ranchi city centre, along NH-75 near Tupudana Chowk. Well-connected by autos, taxis, and buses.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Ranchi Railway Station (15 km away) connects to Delhi, Kolkata, Patna, and Bhubaneswar. Autos and cabs reach the park from there.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport, Ranchi (11 km away) is the nearest airport. Taxis and rental cars reach the park easily.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/betla_1.webp",
          "/images/destination/betla_2.webp",
          "/images/destination/betla_4.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/BirsaPark/BirsaMrigVihar_Khunti1.jpg", alt: "Birsa Mrig Vihar" },
          { img: "/images/destination/Lodh2.webp", alt: "Lodh Waterfall" },
          { img: "/images/destination/dalma1.webp", alt: "Dalma Wildlife Sanctuary" },
          { img: "/images/destination/Patratu1.webp", alt: "Patratu Valley" }
        ]
      }
    ],
  },
{
    id: 3,
    image: '/images/destination/Religious_Tourism.webp',
    title: 'Religious Tourism',
    desc1: 'Journey through sacred and revered destinations steeped in deep devotion, ancient traditions, and rich cultural heritage across the vibrant state of Jharkhand.',
    desc2: 'Visit some of Jharkhand’s most revered spiritual sites, including the famous Baidyanath Dham, the holy Parasnath Hill, and the iconic Rajrappa Temple. Experience the profound spiritual essence, ancient rituals, and religious practices that continue to define and shape the region’s unique religious identity and cultural landscape.',
    data: [
      {
        title: "Baidyanath Temple",
        description: [
          "Baidyanath Temple, located in Deoghar, Jharkhand, is one of the twelve sacred Jyotirlingas of Lord Shiva and a major pilgrimage site in India.",
          "The temple complex houses the revered Baidyanath Jyotirlinga, believed to possess divine healing powers.",
          "Devotees throng the temple to participate in the grand Mangla Aarti (morning) and Shringar Aarti (evening), creating a spiritually charged atmosphere with chanting, bells, and devotional hymns.",
          "The sacred Shivaganga Pond, where pilgrims take a holy dip before entering the temple, is said to cleanse sins.",
          "Nearby attractions include the Maa Parvati Temple, Kal Bhairav Mandir, and the impressive Naulakha Mandir (3 km away).",
          "The bustling market around the temple offers religious souvenirs like Rudraksha malas, Shiva lingams, and local sweets such as Tilkut and Malpua."
        ],
        history: [
          "The temple's origins are steeped in mythology, with legends linking it to Ravana, who is said to have carried the Jyotirlinga from Mount Kailash.",
          "Historical records suggest the temple was built in the 8th century by King Vikramaditya of the Gupta dynasty.",
          "Over the centuries, it has been renovated and expanded by various rulers, including the Palas and the Mughals.",
          "The temple gained prominence during the British era when it became a major pilgrimage center.",
          "The annual Shravani Mela (July–August) attracts millions of devotees who walk barefoot from Sultanganj to Deoghar, carrying holy Ganga water to offer to the Jyotirlinga."
        ],
        bestTimeToVisit: [
          "The ideal time to visit is during the cooler months (October to March) when temperatures range between 15–30°C.",
          "The Shravani Mela (July–August) is a spiritually significant period but can be crowded.",
          "Summers (April–June) are hot (up to 45°C), while monsoons (July–September) bring heavy rainfall."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Deoghar is well-connected by road, with regular buses and taxis from major cities like Ranchi (270 km), Patna (280 km), and Kolkata (370 km).",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Deoghar Junction (4 km away), which is well-connected to Delhi, Kolkata, and Patna. Auto-rickshaws and taxis are available from the station.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Deoghar Airport (12 km away), with limited connectivity. Birsa Munda Airport in Ranchi (270 km away) has regular flights from major cities. Taxis are available from both airports.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/Baidyanth1.webp",
          "/images/destination/Baidyanth2.webp",
          "/images/destination/Baidyanth3.webp"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Deori1.webp", alt: "Deori Mandir" },
          { img: "/images/destination/Luguburu1.webp", alt: "Luguburu Ghantabari" },
          { img: "/images/destination/Rajrappa1.webp", alt: "Rajrappa Temple" },
          { img: "/images/destination/Yogni_sthan1.webp", alt: "Yogini Sthan Godda" }
          
        ]
      },

      {
        title: "Deori Mandir",
        description: [
          "Deori Mandir, located in Deori, Jharkhand, is a unique temple dedicated to Maa Dewri, a fierce form of Goddess Durga.",
          "The temple is renowned for its rare 3-foot-tall stone idol of the goddess with 16 arms, each holding weapons, flowers, and sacred symbols.",
          "A fascinating blend of tribal and Hindu traditions is observed here—Munda Pahan priests perform rituals six days a week, while Brahmins conduct worship on the seventh day.",
          "Devotees participate in the special ritual of tying red or yellow threads (mannat ki dor) on bamboo poles to make wishes.",
          "A unique tradition here is returning to untie the thread if the wish is fulfilled.",
          "The temple features original stone doors and has been enhanced with Odisha-style carvings during recent renovations.",
          "The spiritual atmosphere, combined with the temple’s distinctive customs, makes it a must-visit for devotees and cultural enthusiasts."
        ],
        history: [
          "The origins of Deori Mandir are deeply rooted in tribal and Hindu folklore, with the goddess believed to be a protector of the local Munda tribe.",
          "The temple has been a sacred site for centuries, serving as a spiritual center for both tribal communities and Hindu devotees.",
          "Over time, the temple has undergone renovations, blending traditional tribal architecture with Hindu temple art, particularly visible in the Odisha-style carvings added in recent years.",
          "The unique worship practices, combining tribal and Brahminical traditions, highlight the temple’s cultural significance in Jharkhand."
        ],
        bestTimeToVisit: [
          "The ideal time to visit Deori Mandir is during the cooler months (October to March), when the weather is pleasant (15–30°C).",
          "Festivals like Navratri (September–October) and Chaitra Navratri (March–April) see special celebrations, attracting more devotees.",
          "Summers (April–June) can be hot (up to 40°C), while monsoons (July–September) bring moderate rainfall, making travel slightly challenging.",
          "Navratri (Sept–Oct / Mar–Apr): Grand celebrations with special rituals and cultural performances."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Deori is well-connected by road, with regular buses and taxis from Ranchi (70 km), Jamshedpur (110km), and other major cities in Jharkhand. Private vehicles can also be hired for a comfortable journey.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Ranchi Junction (70 km away), which is well-linked to major cities like Kolkata, Delhi, and Patna. From Ranchi, taxis and buses are available to Deori.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport in Ranchi (75 km away), with regular flights from Delhi, Kolkata, Mumbai, and other cities. Taxis and buses can be taken from the airport to reach Deori.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/Deori1.webp",
          "/images/destination/Deori2.webp",
          "/images/destination/Deori3.webp"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Baidyanth1.webp", alt: "Baidyanath Temple" },
          { img: "/images/destination/Luguburu1.webp", alt: "Luguburu Ghantabari" },
          { img: "/images/destination/Rajrappa1.webp", alt: "Rajrappa Temple" },
          { img: "/images/destination/Yogni_sthan1.webp", alt: "Yogini Sthan Godda" }
        ]
      },

      {
        title: "Luguburu Ghantabari",
        description: [
          "Luguburu Ghantabari, nestled in the Bokaro district of Jharkhand, is a sacred pilgrimage site revered by the Santhal tribe as the abode of their spiritual guru, Lugu Baba.",
          "The name translates to 'revered deity mountain' in Santhali, reflecting its deep cultural and religious significance.",
          "The site is famed for its annual Kartik Purnima festival, Jharkhand’s official state festival, where lakhs of Santhals gather to discuss tribal customs, language, and social upliftment.",
          "The event reenacts the historic 12-year Santhal constitutional assembly held centuries ago under Lugu Baba’s leadership, where tribal laws and rituals were codified.",
          "Devotees trek 7 km uphill to reach Lugu Baba’s meditation cave (Ghiri Dola), a powerful spiritual spot where offerings like flowers, rice, and holy water are made to nature spirits (Sarna sthal).",
          "The site’s serene landscape—lush hills, waterfalls, and dense forests—adds to its spiritual allure."
        ],
        history: [
          "Luguburu’s origins trace back to Sosnok Jug, an era in Santhal folklore, and gained prominence as a pilgrimage site in the early 2000s.",
          "The International Sarna Dharma Conference, held here since 2001, revitalized its role as a cultural hub for tribal identity and nature worship (Sarnaism).",
          "Legends speak of secret tunnels linking the cave to Maa Chhinnamastika Temple, though these remain unexplored."
        ],
        bestTimeToVisit: [
          "November–December: Ideal for the Kartik Purnima festival (November) and pleasant weather (15–30°C).",
          "Amavasya/Purnima: Monthly ceremonies attract devotees with traditional rituals.",
          "Avoid monsoons (July–September) due to heavy rainfall."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Nearest bus stand: Gomia (16 km from the site). Regular buses/taxis ply from Bokaro (69 km), Ranchi (104 km.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "Closest stations: Bokaro Steel City (69 km). Taxis are available to Luguburu.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "Birsa Munda Airport, Ranchi (120–130 km). Hire a taxi for a 3-hour drive.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/Luguburu1.webp",
          "/images/destination/Luguburu2.webp",
          "/images/destination/Luguburu3.webp"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Deori1.webp", alt: "Deori Mandir" },
          { img: "/images/destination/Baidyanth1.webp", alt: "Baidyanath Temple" },
          { img: "/images/destination/Rajrappa1.webp", alt: "Rajrappa Temple" },
          { img: "/images/destination/Yogni_sthan1.webp", alt: "Yogini Sthan Godda" }
        ]
      },

      {
        title: "Rajrappa Temple",
        description: [
          "Rajrappa Temple, located at the confluence of the Damodar and Bhairavi (Bhera) rivers in Jharkhand, is one of the most sacred Shakti Peethas in India.",
          "The temple is dedicated to Goddess Chhinnamasta, a fierce form of Devi Durga, depicted as a headless deity standing on the bodies of Kamadeva and Rati—a rare and powerful Tantric representation.",
          "The temple’s unique architecture, with intricate carvings and a Nagara-style structure, adds to its spiritual aura.",
          "The site is also famous for the Rajrappa Falls, where the Bhera River dramatically cascades 30 feet into the Damodar, creating a breathtaking natural spectacle.",
          "The surrounding landscape features incised meanders, a geological marvel formed over 66 million years, and a polycyclic valley showcasing the Damodar River’s two-tiered gorge.",
          "Visitors can trek around the valley for panoramic views or capture stunning sunrise/sunset shots where the Bhera River appears as a 'hanging valley' over the Damodar."
        ],
        history: [
          "The temple’s origins trace back to ancient Hindu scriptures, with legends suggesting its establishment by King Bhairav Singh of Ramgarh in the 13th century to commemorate his victory over Mughal forces.",
          "It is also believed to be one of the 10 Mahavidyas, where the divine energy of Goddess Kali is worshipped.",
          "The site holds immense significance for tribal communities, particularly the Santhals, who perform ancestral rites by immersing ashes in the Damodar River.",
          "Over the centuries, the temple has been a center of Tantric worship, attracting devotees seeking spiritual power and blessings."
        ],
        bestTimeToVisit: [
          "October to March: Pleasant weather (10–25°C), ideal for sightseeing and temple visits.",
          "Navratri (Sept–Oct / Mar–Apr): Grand celebrations with special rituals and cultural performances.",
          "Avoid monsoon (July–September) due to heavy rainfall, which may hinder travel."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Rajrappa is well-connected via NH-23, with buses and taxis available from:Ranchi (70 km),Bokaro Steel City (68 km),Hazaribagh (74 km).",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Ramgarh Cantonment (28 km). From there, taxis and local transport are available to the temple.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport, Ranchi (75 km), with flights from major cities like Delhi, Kolkata, and Mumbai. Taxis can be hired for a 2-hour drive to Rajrappa.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/Rajrappa1.webp",
          "/images/destination/Rajrappa2.webp",
          "/images/destination/Rajrappa3.webp"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Deori1.webp", alt: "Deori Mandir" },
          { img: "/images/destination/Baidyanth1.webp", alt: "Baidyanath Temple" },
          { img: "/images/destination/Luguburu1.webp", alt: "Luguburu Ghantabari" },
          { img: "/images/destination/Yogni_sthan1.webp", alt: "Yogini Sthan Godda" }
        ]
      },

      {
        title: "Yogini Sthan Godda",
        description: [
          "Yogini Sthan, located in Pathargama block of Godda district, Jharkhand, is a powerful Shakti Peetha dedicated to Goddess Yogini, believed to be a manifestation of Goddess Sati.",
          "The temple is renowned for its unique Tantric rituals, similar to those performed at Kamakhya Temple, where priests worship the sacred Pind (divine stone) representing the goddess's energy.",
          "The temple’s spiritual aura is heightened by its secluded cave shrine, accessible via 354 steep steps, where devotees experience an otherworldly transition from darkness to light upon entering.",
          "The site is deeply connected to the Mahabharata era, referred to as 'Gupta Yogini,' where the Pandavas are said to have spent part of their exile.",
          "The temple’s energy peaks during Amavasya (new moon) and Mahashivratri, attracting Tantric practitioners for intense spiritual practices."
        ],
        history: [
          "Legends trace the temple’s origins to the Dwapara Yuga, with ties to the Mahabharata.",
          "Historically, it was a center for Nara Bali (human sacrifice) until the British banned the practice.",
          "The temple’s Tantric traditions, including Pind worship and rituals mirroring Kamakhya, highlight its significance in Shakta traditions.",
          "The nearby Manokamna Mandi and ancient banyan tree, where sages once meditated, add to its mystical legacy."
        ],
        bestTimeToVisit: [
          "October–March: Pleasant weather (15–30°C), ideal for visits.",
          "Amavasya/Mahashivratri: Witness peak Tantric ceremonies.",
          "Avoid monsoons (July–September) due to heavy rainfall."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Located 15 km from Godda on the Jasidih-Deoghar Highway. Taxis/buses ply from Godda and Deoghar (93 km).",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "Nearest stations:  Godda (15 km) Auto-rickshaws/taxis available.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "Birsa Munda Airport, Ranchi (350 km Hire a taxi for a 6–7 hour drive.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/Yogni_sthan1.webp",
          "/images/destination/Yogni_sthan2.webp",
          "/images/destination/Yogni_sthan3.webp"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Deori1.webp", alt: "Deori Mandir" },
          { img: "/images/destination/Baidyanth1.webp", alt: "Baidyanath Temple" },
          { img: "/images/destination/Luguburu1.webp", alt: "Luguburu Ghantabari" },
          { img: "/images/destination/Rajrappa1.webp", alt: "Rajrappa Temple" }
        ]
      },
      {
        title: "Bageshwari Temple, Balbal",
        description: [
          "Bageshwari Temple, located in the quiet village of Balbal in Chatra district, is among the most revered religious spots in the region. ",
          "Dedicated to Goddess Bageshwari, a form of Goddess Durga, the temple is both a spiritual centre and a cultural anchor for the surrounding villages.",
          "People from Chatra and nearby districts frequently visit this shrine, especially during festivals, to seek blessings and to be part of age-old rituals that have been practiced here for generations.",
          "The temple stands as a reminder of how deeply faith is woven into the everyday life of Jharkhand’s people.",
          "Unlike the large and famous pilgrimage centres that draw national attention, Bageshwari Temple is known for its intimate setting and strong connection to local communities.",
          "It represents the continuity of traditions that link mythology, folk practices, and devotional worship."
        ],
        history:[
          "The religious value of Bageshwari Temple rests in its dedication to Goddess Bageshwari, believed to be a protective deity who safeguards her devotees from harm and ensures prosperity in the region. ",
          "Villagers often describe the temple as the seat of divine power, a place where prayers are not only offered but also answered with sincerity.",
          "Worshippers arrive with offerings of flowers, red cloth, incense, and earthen lamps, which are considered auspicious in the service of the goddess.",
          "During Navratri, the temple becomes the focal point of religious celebration in the area. Devotees observe fasts, perform rituals, and take part in communal prayers that last through the nine days.",
          "On these days, Balbal transforms into a hub of activity as people travel from across Chatra district and neighbouring areas to join the festivities.",
          "The beating of traditional drums, chanting of hymns, and the collective recitation of mantras create an atmosphere of devotion that lingers long after the rituals conclude."
        ],
        bestTimeToVisit: [
          "The best time to visit Bageshwari Temple in Balbal is during the winter and early spring months, from October to March.",
          "The weather in this period remains pleasant, with cool mornings and mild afternoons, making it comfortable for both darshan and exploring the surrounding natural landscape.",
          "Pilgrims also find this season suitable for long hours of worship and participation in local rituals without the discomfort of heat.",
          "If one wishes to experience the temple’s cultural vibrancy, visiting during festivals like Maha Shivratri or Shravan Mela is most rewarding, as the temple becomes a hub of activity, filled with chants, rituals, and a deep spiritual atmosphere."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Bageshwari Temple in Balbal is situated around 45 kilometres from Chatra, the district headquarters. The road journey passes through rural landscapes and small villages. Local buses and shared autos are available, though private vehicles are often more convenient for reaching the temple directly.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway facility is in Hazaribagh Road station, located about 70 kilometres away. From the station, travelers can hire vehicles towards Chatra and then proceed to Balbal village.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "Ranchi’s Birsa Munda Airport is the closest air connection, lying nearly 150 kilometres away. From Ranchi, visitors can travel by road to Chatra and then to Balbal.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/BAGESHWARITEMPLECHARTA1.jpg",
          "/images/destination/BAGESHWARITEMPLECHARTA2.jpg",
          "/images/destination/BAGESHWARITEMPLECHARTA3.jpg",
          "/images/destination/BAGESHWARITEMPLECHARTA4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Deori1.webp", alt: "Deori Mandir" },
          { img: "/images/destination/Baidyanth1.webp", alt: "Baidyanath Temple" },
          { img: "/images/destination/Luguburu1.webp", alt: "Luguburu Ghantabari" },
          { img: "/images/destination/Rajrappa1.webp", alt: "Rajrappa Temple" },
        ]
      },
      {
        title: "Chutonath Mandir Dumka",
        description: [
          "Chutonath Mandir, located in Chutonath Gaon of Jharkhand, is a sacred site that draws countless devotees with its deep-rooted cultural and religious heritage.",
          "Nestled in a serene rural landscape, the temple is dedicated to Lord Shiva and has long been a centre of faith for local communities and visiting pilgrims.",
          "What makes this temple unique is not just the deity it houses, but the surrounding environment where lush greenery, calm village life, and spiritual devotion come together in perfect harmony.",
          "For centuries, Chutonath Mandir has been regarded as a place where prayers and rituals carry profound significance.",
          "The temple serves as a beacon of devotion, especially during the holy month of Shravan, when thousands of devotees undertake their spiritual journeys to worship Lord Shiva.",
          "The local traditions, folk songs, and vibrant fairs organized during festivals add to the temple’s charm, making it not just a religious spot but also a cultural landmark.",
          "Unlike grand architectural marvels in cities, Chutonath Mandir’s appeal lies in its simplicity and the authenticity of rural faith practices.",
          "Walking into the temple premises, one can feel a sense of calm, away from urban chaos, making it a place where spirituality feels more personal and grounding.",
          "For those seeking a genuine connection with Jharkhand’s spiritual roots, Chutonath Mandir provides an experience that is both humbling and inspiring."
        ],
        history: [
          "Chutonath Mandir is primarily a centre of Shaivite worship. Devotees believe that Lord Shiva, revered here as Chutonath, protects the surrounding villages and blesses his followers with peace and prosperity.",
          "Rituals like Rudrabhishek, special prayers during Mahashivratri, and offerings of water and Bel leaves during Shravan are central to the temple’s spiritual rhythm.",
          "The temple is also a focal point during Kanwar Yatra, when pilgrims carry holy water from nearby rivers and offer it to the deity.",
          "The temple is also a focal point during Kanwar Yatra, when pilgrims carry holy water from nearby rivers and offer it to the deity."
        ],
        bestTimeToVisit: [
          "The best time to visit Chutonath Mandir is during Shravan (July–August) and Mahashivratri, when the temple is most vibrant with rituals, fairs, and community gatherings.",
          "The winter months (October–February) are also pleasant for visitors, with comfortable weather for travel and exploration."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Chutonath Mandir is accessible by road from Deoghar and nearby towns. Local buses and shared taxis frequently operate on this route, making it easy for pilgrims and visitors.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Jasidih Junction, which is well-connected to cities like Ranchi, Patna, and Kolkata. From there, taxis and autos are available to reach Chutonath Gaon.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Deoghar Airport, located about 40–50 km away. Regular flights connect it with cities like Delhi and Kolkata. From the airport, one can hire a cab to reach the temple.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/ChutonathMandirDumka1.jpg",
          "/images/destination/ChutonathMandirDumka2.jpg",
          "/images/destination/ChutonathMandirDumka3.jpg",
          "/images/destination/ChutonathMandirDumka4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/DALAHIKUNDBOKARO1.jpg", alt: "Dalahi Kund" },
          { img: "/images/destination/MaaKeraMandirWestSinghbhum1.jpg", alt: "Maa Kera Temple" },
          { img: "/images/destination/KAITHASHIVMANDIRRAMGARH1.jpg", alt: "Kaitha Shiv Mandir, Ramgarh" },
          { img: "/images/destination/MAAAKARSHINIDEVIMANDIRSARAIKELA1.jpg", alt: "Maa Akarshini Devi Temple, Saraikela" }
        ]
      },      
      {
        title: "Rankini Mandir",
        description: [
          "Rankini Mandir, located in Rohinibera near Jadugora in Jharkhand, is a revered shrine that draws devotees from across the region.",
          "The temple is dedicated to Goddess Rankini, worshipped as a protective and powerful deity who safeguards her followers and ensures prosperity.",
          "Nestled in a quiet village setting, the temple stands amid lush greenery and open spaces, creating a serene atmosphere where faith and nature coexist.",
          "The temple is not only a place for prayer but also a cultural focal point for local communities. Villagers and pilgrims alike come to perform rituals, offer prayers, and participate in festivals that have been observed for generations.",
          "Its unassuming structure, simple yet spiritually vibrant, reflects the traditional religious practices of the tribal and rural populations of Jharkhand.",
          "For visitors, the temple provides an opportunity to witness devotional customs closely intertwined with everyday life and local folklore.",
          "Over the years, Rankini Mandir has become synonymous with community celebrations, especially during auspicious occasions like Navratri and other local festivals.",
          "Pilgrims describe the environment as peaceful and uplifting, where the sounds of prayers, devotional songs, and the rhythm of temple bells enhance the spiritual experience.",
          "The temple’s location, away from urban hustle, allows for a more intimate and reflective connection with the divine."
        ],
        history:[
            "The religious significance of Rankini Mandir lies in its dedication to Goddess Rankini, considered a living presence in the temple.",
            "Devotees believe that she offers protection, strength, and blessings to her followers.",
            "Rituals at the temple include offering flowers, red cloth, incense, and food to the goddess, as well as performing aarti twice a day.",
            "Navratri is a particularly important festival at Rankini Mandir, when devotees observe fasts, recite hymns, and perform community prayers.",
            "Oral traditions and local legends emphasize the goddess’s power in safeguarding the land and the people, reinforcing the temple’s role as a spiritual and cultural anchor.",
            "For generations, this temple has been a centre where faith is practiced in a simple yet profound manner, reflecting the deep-rooted devotion of the local population."
        ],
        bestTimeToVisit: [
          "The best time to visit Rankini Mandir is during October to March, when the weather is mild and comfortable for travel and participation in rituals.",
          "The winter months make the surrounding village and landscape pleasant for exploring, while the temple remains lively with devotees during festival periods.",
          "Visiting during Navratri is highly recommended for those who wish to experience the temple’s full spiritual and cultural vibrancy."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Rankini Mandir is approximately 20 kilometres from Jadugora town, connected by rural roads. Local buses, shared autos, and private taxis are available to reach the temple.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Jadugora Station, linking the village with nearby towns and cities. From the station, visitors can hire taxis or take local transport to reach the temple.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport in Ranchi, around 130 kilometres away. From Ranchi, visitors can travel by road using taxis or buses to reach Rohinibera and the temple.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/RinkiniMandirEastSinghbhum1.jpg",
          "/images/destination/RinkiniMandirEastSinghbhum2.jpg",
          "/images/destination/RinkiniMandirEastSinghbhum3.jpg",
          "/images/destination/RinkiniMandirEastSinghbhum4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/BAGESHWARITEMPLECHARTA1.jpg", alt: "Bageshwari Temple, Balbal" },
          { img: "/images/destination/ChutonathMandirDumka1.jpg", alt: "Chutonath Mandir Dumka" },
          { img: "/images/destination/RinkiniMandirEastSinghbhum1.jpg", alt: "Rankini Mandir" },
          { img: "/images/destination/HanthiKeraEastSinghbhum1.jpg", alt: "Hathi Kheda Temple" }
        ]
      },      {
        title: "Hathi Kheda Temple",
        description: [
          "Hathi Kheda is a small yet fascinating natural site located near Lawjora village in Jharkhand.",
          "The area is known for its unique rock formations, open fields, and scenic surroundings that create a peaceful environment for visitors.",
          "Hathi Kheda, which literally translates to “Elephant Rock,” draws attention due to its large boulder formations that resemble elephants, giving the site its name.",
          "The landscape is simple but striking, with gentle slopes, scattered trees, and small water channels that reflect the rural charm of Jharkhand.",
          "For locals and visitors alike, Hathi Kheda serves as a recreational spot where one can enjoy short treks, nature walks, or picnics.", 
          "It is not only a place for visual exploration but also an area where people can connect with the natural environment.",
          "Its calm setting, combined with the distinctive rock shapes, makes it ideal for photography and quiet observation.", 
          "The site’s modest elevation also provides gentle viewpoints over the surrounding countryside, making it an attractive destination for families and small groups looking to spend time outdoors."
        ],
        history: [
          "The main significance of Hathi Kheda is natural.", 
          "The area is home to diverse plant life, including native shrubs and trees that provide shade and habitat for small birds and animals.", 
          "The rock formations, shaped over centuries, are geological features of interest and are a highlight for visitors who enjoy studying or photographing unusual natural structures.", 
          "The terrain encourages exploration on foot and offers a connection to rural landscapes that remain largely untouched by urban development.", 
          "Seasonal streams around the site support local wildlife and help maintain the ecological balance in the region.", 
          "Hathi Kheda thus stands as a simple yet important natural landmark within Jharkhand’s rural landscape."
        ],
        bestTimeToVisit: [
          "The best time to visit Hathi Kheda is from October to March.",
          "During these months, the weather is cool and comfortable, making outdoor exploration enjoyable.", 
          "Winter mornings and late afternoons offer pleasant temperatures for walks and treks.", 
          "Monsoon season between July and September can make the rocks slippery and paths muddy, while the summer months from April to June are generally hot, which can make physical activity uncomfortable."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Hathi Kheda is located about 20 kilometres from the sub-district centre of Lawjora. Roads are mostly rural, and local buses or shared autos are available, though private vehicles are often the easiest way to reach the site.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Lawjora station, which connects to nearby towns and cities. From the station, visitors can hire a local auto or shared vehicle to reach Hathi Kheda.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport in Ranchi, approximately 120 kilometres away. From the airport, travelers can use a combination of train or road transport to reach Lawjora and onward to Hathi Kheda.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/HanthiKeraEastSinghbhum1.jpg",
          "/images/destination/HanthiKeraEastSinghbhum2.jpg",
          "/images/destination/HanthiKeraEastSinghbhum3.jpg",
          "/images/destination/HanthiKeraEastSinghbhum4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/DhwajadhariDhamKoderma1.jpg", alt: "Dhwajadhari Dham, Koderma" },
          { img: "/images/destination/PAGLABABAMANDIRDEOGHAR1.jpg", alt: "Pagla Baba Mandir, Deoghar" },
          { img: "/images/destination/BHAIRAVSTHANBOKARO1.jpg", alt: "Bhairav Place (Bhairav Sthan)" },
          { img: "/images/destination/DALAHIKUNDBOKARO1.jpg", alt: "Dalahi Kund" },
        ]
      },      {
        title: "Jaliya Surya Mandir",
        description: [
          "Jaliya Surya Mandir is a prominent temple dedicated to the Sun God, located in the village of Jaliya in Giridih district, Jharkhand.", 
          "The temple sits in a serene rural setting, surrounded by open fields and scattered trees, creating a calm and spiritual atmosphere for visitors.", 
          "Known for its devotion to Surya, the Sun God, the temple has been an important part of local religious life for generations.",
          "The temple compound is modest in size but carefully maintained by local communities who perform daily rituals and oversee festival preparations.", 
          "Visitors often feel a sense of peace as they approach the temple, drawn by its tranquil surroundings and the steady rhythm of prayers.", 
          "The sunlight hitting the temple at different times of the day creates a warm and radiant ambiance, which enhances the spiritual experience.", 
          "For locals and pilgrims alike, Jaliya Surya Mandir is more than a religious site; it is a centre of cultural continuity and communal gatherings that strengthens village identity."
        ],
        history:[
          "The primary significance of Jaliya Surya Mandir lies in its religious importance as a temple devoted to the Sun God.", 
          "Surya worship has been a part of Indian religious practices for centuries, symbolizing health, vitality, and prosperity.", 
          "Devotees visit the temple to offer prayers during daily rituals and special occasions such as Chhath Puja, when the Sun God is particularly venerated.",
          "During festival periods, the temple becomes a centre of devotional activity, with villagers and pilgrims participating in rituals, offering flowers and water, and performing arati at sunrise and sunset.", 
          "The temple is also known for its oral traditions and local stories that connect the deity with the surrounding landscape, further reinforcing its spiritual relevance.", 
          "The consistent devotion of local communities ensures that the temple remains an active hub of religious life in Giridih district."
        ],
        bestTimeToVisit: [
          "The best time to visit Jaliya Surya Mandir is from October to March.", 
          "In this period, the weather is cool and comfortable, making it suitable for early morning or late afternoon darshan.", 
          "Festivals like Chhath Puja, which usually falls in October or November, are ideal for those who want to witness and participate in traditional rituals.", 
          "Summers can be hot and humid, reducing the comfort of visiting, while the monsoon season can make travel to the village difficult due to slippery rural roads."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Jaliya Surya Mandir is situated approximately 30 kilometres from Giridih town, the district headquarters. Roads are primarily rural, and local buses or shared autos connect the village to Giridih, though private vehicles are more convenient for direct access.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "Jaliya Surya Mandir is situated approximately 30 kilometres from Giridih town, the district headquarters. Roads are primarily rural, and local buses or shared autos connect the village to Giridih, though private vehicles are more convenient for direct access.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Kazi Nazrul Islam Airport in Durgapur, around 150 kilometres away. From the airport, travelers need to take a combination of road and rail transport to reach Giridih and then proceed to Jaliya village.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/JaliySuryaMandirGiridih1.jpg",
          "/images/destination/JaliySuryaMandirGiridih2.jpg",
          "/images/destination/JaliySuryaMandirGiridih3.jpg",
          "/images/destination/JaliySuryaMandirGiridih4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Luguburu1.webp", alt: "Luguburu Ghantabari" },
          { img: "/images/destination/Rajrappa1.webp", alt: "Rajrappa Temple" },
          { img: "/images/destination/Yogni_sthan1.webp", alt: "Yogini Sthan Godda" },
          { img: "/images/destination/BAGESHWARITEMPLECHARTA1.jpg", alt: "Bageshwari Temple, Balbal" }

        ]
      },      
      {
        title: "Narsingh Sthan Temple, Hazaribagh",
        description: [
          "Narsingh Sthan Temple is a historic and spiritual landmark situated in Hazaribagh district of Jharkhand.", 
          "Located on the outskirts of Hazaribagh town, the temple is devoted to Lord Narsingh, the fourth incarnation of Lord Vishnu, symbolizing protection and strength.", 
          "The site is surrounded by gentle hills, scattered trees, and open spaces, giving it a calm and serene atmosphere.", 
          "Unlike major pilgrimage centres, Narsingh Sthan Temple is closely connected to the local community, with villagers and townspeople visiting regularly for daily worship, special occasions, and festivals.",
          "The temple’s setting offers a combination of spiritual and natural appeal.", 
          "Visitors approaching the temple pass through quiet rural roads and small settlements, creating a sense of journey and anticipation.", 
          "The temple itself, modest yet striking, sits on a raised platform and is visible from a short distance, blending harmoniously with the surrounding landscape.", 
          "Many local families bring their children here, and school groups often organize educational trips to learn about the temple’s significance and regional religious traditions.", 
          "Its location amid greenery allows for reflection, meditation, and occasional gatherings without the hustle associated with larger pilgrimage centres."
        ],
        history: [
          "Narsingh Sthan Temple holds strong religious significance in the region.", 
          "Dedicated to Lord Narsingh, the temple represents the theme of protection and the triumph of good over evil.", 
          "Devotees believe that offering prayers here can safeguard them from misfortune and bring blessings to their families.", 
          "The temple attracts regular visitors who perform rituals such as lighting incense, offering flowers, and presenting small donations.",
          "The temple is particularly vibrant during festivals like Holi, Diwali, and Narsingh Jayanti, when devotees from surrounding villages and towns gather to celebrate.", 
          "Traditional songs, bhajans, and chants fill the air, creating a devotional and communal atmosphere.", 
          "Unlike larger temples, the rituals here are deeply rooted in local practices, making them accessible and meaningful for the community.", 
          "The temple also serves as a centre for social cohesion, where people come together for prayers, charity events, and cultural observances, maintaining both spiritual and social connections."
        ],
        bestTimeToVisit: [
          "The best time to visit Narsingh Sthan Temple is between October and March.", 
          "During these months, the weather is cool and comfortable for walking, performing rituals, and spending time outdoors.", 
          "Summers can be hot, with temperatures sometimes exceeding 40 degrees Celsius, while monsoon rains make travel difficult and slippery.", 
          "Visiting during festival times provides a unique cultural experience, though it can be crowded.", 
          "Early mornings and late afternoons are ideal for quiet reflection and photography."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Narsingh Sthan Temple is located approximately 7 kilometres from Hazaribagh town, the district headquarters. Local roads connect the temple to the town, and taxis, auto-rickshaws, and private vehicles are convenient options",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Hazaribagh Town Railway Station, around 8 kilometres from the temple. Visitors can hire taxis or local transport to reach the site.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport in Ranchi, about 150 kilometres away. From the airport, visitors can travel by road to Hazaribagh town and then proceed to the temple.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/NarsinghSthanMandirHazaribagh1.jpg",
          "/images/destination/NarsinghSthanMandirHazaribagh2.jpg",
          "/images/destination/NarsinghSthanMandirHazaribagh3.jpg",
          "/images/destination/NarsinghSthanMandirHazaribagh4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Deori1.webp", alt: "Deori Mandir" },
          { img: "/images/destination/Baidyanth1.webp", alt: "Baidyanath Temple" },
          { img: "/images/destination/HanthiKeraEastSinghbhum1.jpg", alt: "Hathi Kheda Temple" },
          { img: "/images/destination/JaliySuryaMandirGiridih1.jpg", alt: "Jaliya Surya Mandir" }
        ]
      },      
      {
        title: "Maa Ugratara Mandir, Latehar",
        description: [
          "Maa Ugratara Mandir is a revered religious site located in Latehar district of Jharkhand.", 
          "Dedicated to Goddess Ugratara, a fierce form of Goddess Durga, the temple is a spiritual anchor for the surrounding communities.", 
          "Nestled amid gentle hills and rural landscapes, the temple exudes a sense of calm and devotion.", 
          "The journey to the temple passes through small villages and fields, giving visitors a glimpse of local life.", 
          "Unlike larger pilgrimage centres, Maa Ugratara Mandir is known for its intimate and personal atmosphere, where villagers and devotees frequently visit for daily prayers, special rituals, and festival celebrations.",
          "The temple stands on a slightly elevated platform, making it visible from a distance.", 
          "Its architecture is simple yet traditional, with a sanctum, a small courtyard, and a few decorative carvings that reflect local craftsmanship.", 
          "The natural surroundings, with scattered trees and open spaces, provide an ideal environment for meditation and reflection.", 
          "For local residents, the temple is more than a place of worship; it is a cultural hub where stories, customs, and faith are shared across generations.", 
          "Pilgrims often visit not only for spiritual reasons but also to experience the tranquil environment and scenic views of Latehar’s countryside.",
        ],
        history: [
          "Maa Ugratara Mandir holds deep religious importance in the region.",
          "The goddess is regarded as a protector, capable of removing obstacles and safeguarding her devotees from harm.", 
          "Worshippers come to the temple to offer flowers, incense, and red cloth as symbols of devotion.", 
          "The temple also hosts special rituals, particularly during Navratri, when devotees perform fasting, prayers, and communal ceremonies over nine days.",
          "During festival seasons, the temple becomes a focal point for local gatherings.", 
          "Devotional songs, hymns, and chants create a vibrant spiritual atmosphere.", 
          "People from nearby villages often participate in rituals together, strengthening community bonds.", 
          "The goddess is believed to grant blessings related to prosperity, protection, and success, making the temple a center for both personal devotion and social cohesion.", 
          "Its importance is enhanced by oral traditions that link local history and legends to the goddess, reinforcing faith across generations."
        ],
        bestTimeToVisit: [
          "The best time to visit Maa Ugratara Mandir is from October to March.", 
          "During these months, the weather is cool and comfortable, ideal for walking around the temple, participating in rituals, and spending time outdoors.", 
          "Summers can be very hot, making visits less enjoyable, while the monsoon season brings heavy rains and slippery paths.",
          "Visiting during festivals like Navratri offers a unique spiritual and cultural experience, though it is busier than usual."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Maa Ugratara Mandir is situated about 25 kilometres from Latehar, the district headquarters. Roads connect the temple to the town, and taxis, shared autos, or private vehicles are commonly used.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Latehar Railway Station, approximately 25 kilometres away. From there, travelers can hire taxis or shared vehicles to reach the temple.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport in Ranchi, around 140 kilometres from the temple. From Ranchi, visitors can travel by road to Latehar and then proceed to Maa Ugratara Mandir.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/MaaUgrataraMandirLatehar1.jpg",
          "/images/destination/MaaUgrataraMandirLatehar2.jpg",
          "/images/destination/MaaUgrataraMandirLatehar3.jpg",
          "/images/destination/MaaUgrataraMandirLatehar4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/JaliySuryaMandirGiridih1.jpg", alt: "Jaliya Surya Mandir" },
          { img: "/images/destination/NarsinghSthanMandirHazaribagh1.jpg", alt: "Narsingh Sthan Temple, Hazaribagh" },
          { img: "/images/destination/MaaUgrataraMandirLatehar1.jpg", alt: "Maa Ugratara Mandir, Latehar" },
          { img: "/images/destination/TanginathGumla1.jpg", alt: "Tanginath Mandir, Gumla" }
        ]
      },      
      {
        title: "Tanginath Mandir, Gumla",
        description: [
          "Tanginath Mandir is a revered temple located in the quiet village of Tanginath in Gumla district, Jharkhand.", 
          "Nestled amid gently rolling hills and patches of forest, the temple presents a serene atmosphere for devotees and visitors.", 
          "Unlike larger, heavily visited temples, Tanginath Mandir retains a sense of intimacy and community.", 
          "The area surrounding the temple is peaceful, dotted with small streams and agricultural fields, giving a picturesque view of rural Jharkhand.", 
          "Local people, as well as visitors from neighbouring villages, come here regularly to offer prayers, especially during festive occasions.", 
          "The temple’s setting encourages reflection and quiet meditation, and the pathway leading to it passes through scenic landscapes that showcase the simplicity and beauty of Gumla district.",
          "The temple is an important part of local life. Farmers, families, and students often pause here during their daily routines or visits to nearby villages.", 
          "Tanginath Mandir also serves as a cultural anchor for the surrounding communities, hosting seasonal fairs and small religious gatherings that bring people together and preserve traditional practices.", 
          "The quiet surroundings allow visitors to experience the temple in a contemplative environment, away from the bustle of major pilgrimage sites."
        ],
        history: [
          "Tanginath Mandir holds deep religious value as a place of worship dedicated to Lord Shiva.", 
          "Devotees believe that offering prayers at the temple brings protection, prosperity, and relief from personal hardships.",
          "Rituals here are performed according to local traditions, often involving flowers, incense, and lighting of earthen lamps.", 
          "During Shivratri and other significant festivals, the temple becomes a focal point of activity as villagers and devotees from neighbouring areas participate in collective worship, singing hymns, and reciting mantras.",
          "The temple also reflects the living tradition of rural worship, where spirituality is intertwined with daily life.", 
          "Oral histories suggest that the temple has been a center of devotion for generations, and local priests continue to maintain its customs.", 
          "Unlike large temples with elaborate architecture, Tanginath Mandir’s appeal lies in its simplicity, fostering a strong emotional connection between the devotees and the divine.", 
          "The surrounding environment, with its green hills and quiet streams, reinforces the sense of sacredness and tranquility, making it a preferred destination for personal reflection and spiritual retreat."
        ],
        bestTimeToVisit: [
          "The ideal period to visit Tanginath Mandir is between October and March, when the weather is cool and pleasant.", 
          "During these months, visitors can comfortably walk to the temple, participate in rituals, and enjoy the surrounding natural scenery.", 
          "Summers are hot and humid, which can make travel less comfortable, while monsoon rains may make the paths slippery and difficult to navigate safely.", 
          "Visiting during festival periods such as Shivratri can provide a deeper cultural experience, as the temple comes alive with prayers, music, and communal devotion."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Tanginath Mandir is approximately 30 kilometres from Gumla, the district headquarters. The route passes through rural roads and small settlements, and taxis or private vehicles are convenient for reaching the temple.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Ranchi Road Junction, around 65 kilometres from Tanginath. From the station, visitors can hire taxis or local transport to reach the temple.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport in Ranchi, roughly 70 kilometres from Tanginath Mandir. From the airport, one can travel by road via Ranchi to Gumla and then proceed to the temple.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/TanginathGumla1.jpg",
          "/images/destination/TanginathGumla2.jpg",
          "/images/destination/TanginathGumla3.jpg",
          "/images/destination/TanginathGumla4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/BAGESHWARITEMPLECHARTA1.jpg", alt: "Bageshwari Temple, Balbal" },
          { img: "/images/destination/ChutonathMandirDumka1.jpg", alt: "Chutonath Mandir Dumka" },
          { img: "/images/destination/RinkiniMandirEastSinghbhum1.jpg", alt: "Rankini Mandir" },
          { img: "/images/destination/HanthiKeraEastSinghbhum1.jpg", alt: "Hathi Kheda Temple" }
        ]
      },     
      {
        title: "Devleshwar Dham, Nala",
        description: [
          "Devleshwar Dham is one of the oldest and most revered Shiva temples in the Nala block of Jamtara district.", 
          "According to local legends, an ancient sage named Deval performed intense penance in the forest here.", 
          "Pleased by his devotion, Lord Shiva appeared before Deval, who attained spiritual perfection at that moment.", 
          "At that sacred site, a naturally emerged Shiva Lingam (a self-manifested symbol of Shiva) is believed to have appeared—this is the sanctified focus of devotion today.", 
          "Later, the local zamindar (landlord) Ramnarayan Singh, guided by a dream, established the temple on this very spot.", 
          "It has since become a place of deep faith and community reverence.", 
          "A notable feature near the temple is the “Bhud‐Bhudi” hot water spring about half a kilometre away, where pilgrims bathe a practice sacred to locals and visitors alike."
        ],
        history: [
          "Devleshwar Dham draws devotees year-round.", 
          "Many believe that those who come seeking blessings rarely return empty-handed.", 
          "The temple is especially alive during festivals like Shravan Mela, Mahashivratri, and Chadak Puja, when pilgrims perform rituals, offer prayers, and take dips in the hot spring.", 
          "Water offerings (jal arpan), processions, bhajans, and smruti recitations mark these sacred days.", 
          "Pilgrims often bring holy water from the nearby Ajay river to offer at the deity's feet.", 
          "The temple sits amidst wooded rural surroundings, offering calm away from town.",
          "The hot spring nearby known as Bhud-Bhudi adds a natural charm and spiritual layer, especially as devotees believe its warm waters have sacred cleansing properties."
        ],
        bestTimeToVisit: [
          "While devotees come throughout the year, certain times are particularly auspicious: Shravan Mela (July–August): Marked by a festive mood, vibrant rituals, community gatherings, and extended devotional activities. Other Festivals: Mahashivratri and Chadak Puja bring intense spiritual energy to the site.",
          "Anytime Else: Off-festival seasons offer calm, reflective access for personal prayer and quiet amid nature."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Devleshwar Dham is located within Nala block, Jamtara district. Though specific travel logistics aren’t documented, Nala lies approximately 27 km from Jamtara town (the district headquarters) and is accessible by local road.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is likely Jamtara; buses or local transports can then take you toward Nala. ",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/DevleshwarDhamJamtara1.jpg",
          "/images/destination/DevleshwarDhamJamtara2.jpg",
          "/images/destination/DevleshwarDhamJamtara3.jpg",
          "/images/destination/DevleshwarDhamJamtara4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/JaliySuryaMandirGiridih1.jpg", alt: "Jaliya Surya Mandir" },
          { img: "/images/destination/NarsinghSthanMandirHazaribagh1.jpg", alt: "Narsingh Sthan Temple, Hazaribagh" },
          { img: "/images/destination/MaaUgrataraMandirLatehar1.jpg", alt: "Maa Ugratara Mandir, Latehar" },
          { img: "/images/destination/TanginathGumla1.jpg", alt: "Tanginath Mandir, Gumla" }
        ]
      },    
      {
        title: "Jharkhand Dham",
        description: [
          "Jharkhand Dham, located in Tundi block of Giridih district, is a famous religious site dedicated to Lord Shiva.",
          "Known as the Deoghar of Giridih it attracts a large number of devotees throughout the year, especially during the holy month of Shravan, when Kanwariyas visit in huge numbers to offer water to Lord Shiva."
        ],
        history: [
          "This temple is deeply rooted in faith and is considered one of the most sacred Shiva temples in Jharkhand.", 
          "Pilgrims believe that offering prayers here with a pure heart fulfils wishes and brings peace.", 
          "During Shravan, the temple becomes a hub of spiritual activity with devotees carrying water from nearby rivers to perform Jalabhishek.", 
          "The temple stands out with its traditional design and serene surroundings.",
          "It is surrounded by lush greenery and a peaceful atmosphere, making it not just a religious destination but also a place for inner calm and reflection."
        ],
        bestTimeToVisit: [
          "The best time to visit Jharkhand Dham is during October to March, when the weather is pleasant for travel and temple visits.", 
          "For devotees, the most significant period is the month of Shravan (July–August), when special rituals, processions, and offerings take place, and the temple is alive with spiritual energy.", 
          "Maha Shivratri, usually falling in February or March, is another peak time to witness grand celebrations."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Jharkhand Dham is well connected by road. Buses, autos, and private vehicles from Giridih town (approx. 25 km away) can easily take visitors to the site.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Giridih Railway Station, which connects to major routes.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The nearest airport is Deoghar Airport (approx. 100 km), followed by Ranchi Airport.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/JharkhandDhamGiridih1.jpg",
          "/images/destination/JharkhandDhamGiridih2.jpg",
          "/images/destination/JharkhandDhamGiridih3.jpg",
          "/images/destination/JharkhandDhamGiridih4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Deori1.webp", alt: "Deori Mandir" },
          { img: "/images/destination/Baidyanth1.webp", alt: "Baidyanath Temple" },
          { img: "/images/destination/Luguburu1.webp", alt: "Luguburu Ghantabari" },
          { img: "/images/destination/Rajrappa1.webp", alt: "Rajrappa Temple" }
        ]
      },    
      {
        title: "Dhwajadhari Dham, Koderma",
        description: [
          "Perched roughly 0.5 kilometres from Koderma district headquarters, Dhwajadhari Dham sits atop Dhwajadhari Hill—a sacred spot named for the hill’s legendary connection to Rishi Kardam, who is believed to have performed penance here in the Dwapara Yuga.",
          "Pleased by his devotion, Lord Shiva is said to have appeared and blessed him with a trident and battle flag (dhwaja).",
          "From that moment, devotees began installing flags and tridents at the summit, giving the hill its name.",
          "Today, it remains a key pilgrimage and cultural site."
        ],
        history:[
          "Dhwajadhari Dham is more than a temple complex, it’s revered as the spiritual abode of Lord Shiva, the very place where Shiva blessed Kardam Rishi.",
          "Devotees ascend its 777 steps to offer water ablution (jalabhishek) to the Shiva lingam.", 
          "Installing a flag or trident on the hill is considered especially auspicious, believed to fulfill deep-rooted wishes.",
          "Today, it’s a center of devotion throughout the year, but it becomes especially vibrant during Sawan (the holy month) and Mahashivratri.",
          "While Dhwajadhari Hill isn’t famed for sweeping landscapes, its elevation offers unique perspectives and a quiet, forested ascent.",
          "That journey up connects spiritual reflection with nature, blending devotion with scenic calm."
        ],
        bestTimeToVisit: [
          "Mahashivratri: Expect a spiritually rich, vibrant atmosphere with rituals, fairs, and vibrant gatherings.",
          "Sawan Month (July–August): A season of devotion, when pilgrims regularly ascend the steps and participate in religious rites.",
          "Outside festival periods, the Dham offers a peaceful spiritual retreat with minimal crowds and a quiet setting.",
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Dhwajadhari Dham is about 10 km from Koderma Railway Station and just 0.5 km from the DC’s office. Visitors usually reach via auto, cab, or even on foot.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "Well-connected via Koderma Railway Station, which links major cities across India.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The nearest airports are Lok Nayak Jayaprakash Airport in Patna (165 km) and Birsa Munda Airport in Ranchi (178 km).",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/DhwajadhariDhamKoderma1.jpg",
          "/images/destination/DhwajadhariDhamKoderma2.jpg",
          "/images/destination/DhwajadhariDhamKoderma3.jpg",
          "/images/destination/DhwajadhariDhamKoderma4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/RinkiniMandirEastSinghbhum1.jpg", alt: "Rankini Mandir" },
          { img: "/images/destination/HanthiKeraEastSinghbhum1.jpg", alt: "Hathi Kheda Temple" },
          { img: "/images/destination/JaliySuryaMandirGiridih1.jpg", alt: "Jaliya Surya Mandir" },
          { img: "/images/destination/NarsinghSthanMandirHazaribagh1.jpg", alt: "Narsingh Sthan Temple, Hazaribagh" },

        ]
      },    
      {
        title: "Pagla Baba Mandir, Deoghar",
        description: [
          "Nestled about 8 km from Deoghar’s Tower Chowk, along the JasidihRohini road, Pagla Baba Mandir presents a tranquil alternative to the mainstream pilgrimage bustle.",
          "Despite its modest size, it's rooted deeply in spiritual devotion, local culture, and a compelling folk legacy.",
          "Unlike typical temple complexes, this ashram offers a meditative atmosphere that resonates with both seekers and curious travelers alike."
        ],
        history: [
          "The temple was founded by Leelananda Thakur, affectionately known as Pagla Baba.",
          "Originally from Bangladesh, he established the mandir during the early 20th century, laying the foundations of a spiritual sanctuary that still attracts devotees today.",
          "The central icons of devotion here are the imposing Radha Krishna idols, crafted from eight metals (ashtadhatu) and weighing around 600 kg.",
          "These idols are deeply revered and form the spiritual heart of the ashram."
        ],
        bestTimeToVisit: [
          "Daily visits: Mornings are best soft light, fewer crowds, and an ideal time to absorb the quietude.",
          "Janmashtami: If you’re drawn to cultural energy, visiting during the festival elevates the experience, blending devotion with community celebrations.",
          "Avoid peak midday hours if you’re after calm. Otherwise, the ashram is open for visitors throughout the day.",
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "The ashram sits roughly 8 km from Tower Chowk, en-route to Jasidih. It’s easily accessible by car, taxi, or auto-rickshaw.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "Jasidih Junction is the closest major railhead just a few kilometres away making it convenient for travelers arriving by train.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The nearest airport is Deoghar Airport for domestic flights; alternatively, Ranchi’s Birsa Munda Airport is also an option, around 250 km away.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/PAGLABABAMANDIRDEOGHAR1.jpg",
          "/images/destination/PAGLABABAMANDIRDEOGHAR2.jpg",
          "/images/destination/PAGLABABAMANDIRDEOGHAR3.jpg",
          "/images/destination/PAGLABABAMANDIRDEOGHAR4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Deori1.webp", alt: "Deori Mandir" },
          { img: "/images/destination/Baidyanth1.webp", alt: "Baidyanath Temple" },
          { img: "/images/destination/JharkhandDhamGiridih1.jpg", alt: "Jharkhand Dham" },
          { img: "/images/destination/DhwajadhariDhamKoderma1.jpg", alt: "Dhwajadhari Dham, Koderma" }
        ]
      },      
      {
        title: "Bhairav Place (Bhairav Sthan)",
        description: [
          "Bhairav Place, also known as Bhairav Sthan, is an ancient spiritual site located in Bhojudih village, Chandankiyari block, around 39 km from Bokaro Steel City.",
          "It is situated near the Bokaro–Dhanbad border and is regarded as one of the most significant cultural and religious landmarks of the district.",
          "The site holds a blend of archaeology, mythology, and living traditions, making it a place where history and spirituality meet.",
          "Local communities visit the temple regularly, believing their prayers are answered here"
        ],
        history: [
          "According to local legends, the place is connected to the Mahabharata era.",
          "It is believed that during the Pandavas’ exile, they stayed here for some time, and this region came to be known as “Kunti Vairjit Kshetra.” Folklore says that Arjuna struck the ground with his arrow, and from that strike emerged a spring, now known as the Gupt Ganga.",
          "This natural water source flows continuously and is considered sacred.",
          "People believe that drinking this water cures stomach-related ailments and keeps the body healthy.",
          "The temple at Bhairav Place houses idols carved from black schist stone, dated by archaeologists to the 8th–12th century.",
          "Despite its age, daily worship and rituals continue at the temple, keeping the ancient traditions alive."
        ],
        bestTimeToVisit: [
          "The site remains open throughout the year, but there are specific times when it becomes especially vibrant: New Year’s Day: Devotees begin the year with worship and rituals at Bhairav Place.",
          "Bhairav Mahotsav (September): The cultural festival fills the site with devotional and festive energy.",
          "Winter Season: Pleasant weather makes the area ideal for picnics and spiritual visits.",
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "The nearest railway station is Bhojudih Junction, about 4 km away. Bokaro Junction is another option, around 48 km from the site.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "Bhairav Place is accessible by road from Bokaro Steel City and Dhanbad. Local vehicles, cabs, or private cars are the most convenient options.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport in Ranchi, from where one can travel by train or road to Bokaro.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/BHAIRAVSTHANBOKARO1.jpg",
          "/images/destination/BHAIRAVSTHANBOKARO2.jpg",
          "/images/destination/BHAIRAVSTHANBOKARO3.jpg",
          "/images/destination/BHAIRAVSTHANBOKARO4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/HanthiKeraEastSinghbhum1.jpg", alt: "Hathi Kheda Temple" },
          { img: "/images/destination/JaliySuryaMandirGiridih1.jpg", alt: "Jaliya Surya Mandir" },
          { img: "/images/destination/NarsinghSthanMandirHazaribagh1.jpg", alt: "Narsingh Sthan Temple, Hazaribagh" },
          { img: "/images/destination/MaaUgrataraMandirLatehar1.jpg", alt: "Maa Ugratara Mandir, Latehar" },
        ]
      },      
      {
        title: "Dalahi Kund",
       description: [
          "Dalahi Kund, located in Jaridih block of Bokaro district, is a self-originated sacred water reservoir known for both its religious significance and natural charm.",
          "It is a centre of faith for locals and a major attraction for visitors.",
        ],
        history:[
          "The religious importance of this kund is linked to the nearby temple of Dalahi Gosai Devta.",
          "Locals believe that bathing in its water’s cures skin diseases, attributed to the natural presence of sulphur.",
          "Every year, during Makar Sankranti, a grand fair is held here, offering a vibrant glimpse of local culture and traditions.",
          "The most unique feature of Dalahi Kund is its acoustic response—when someone claps or raises their voice, bubbles rise in the water as if it is surging upward.",
          "This natural phenomenon astonishes visitors.",
          "The calm and scenic surroundings make it an ideal picnic spot."
        ],
        bestTimeToVisit: [
          "Makar Sankranti (January): The best time to enjoy the grand fair and cultural festivities.",
          "Winter (November–February): Pleasant weather, ideal for rituals and picnics.",
          "Year-round: Special worship ceremonies are held every Sunday."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Easily accessible from Bokaro Bus Stand (Naya Mor) via Jaridih.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest railway station is Bokaro Junction.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "RThe nearest airport is Birsa Munda Airport in Ranchi.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/DALAHIKUNDBOKARO1.jpg",
          "/images/destination/DALAHIKUNDBOKARO2.jpg",
          "/images/destination/DALAHIKUNDBOKARO3.jpg",
          "/images/destination/DALAHIKUNDBOKARO4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/DevleshwarDhamJamtara1.jpg", alt: "Devleshwar Dham, Nala" },
          { img: "/images/destination/JharkhandDhamGiridih1.jpg", alt: "Jharkhand Dham" },
          { img: "/images/destination/DhwajadhariDhamKoderma1.jpg", alt: "Dhwajadhari Dham, Koderma" },
          { img: "/images/destination/PAGLABABAMANDIRDEOGHAR1.jpg", alt: "Pagla Baba Mandir, Deoghar" }
        ]
      },      
      {
        title: "Maa Kera Temple",
       description: [
          "Maa Bhagwati Kera Temple, more affectionately referred to as Maa Kera Temple, is a centuries-old spiritual center roughly 10 km from Chakradharpur.",
          "The site began as a humble shrine under trees and later became a proper temple under King Lakshmi Narayan Singhdev, son of King Loknath Singhdev.",
          "Today, it stands as a significant beacon of faith, where thousands gather during annual festivals to pay homage.",        ],
        history: [
          "The temple roots stretch back around 300 to 350 years.",
          "It is a highly revered Shakti Peetha in the Kolhan region, drawing worshippers from Jharkhand, and neighboring Odisha, Bihar, and West Bengal.",
          "Many devotees perform extreme acts of devotion like walking on fire embers or lying on thorn beds—believing their wishes will be granted in return.",
          "The highlight is the Kera Mela, held from approximately 10 to 14 April each year.",
          "This is one of the largest fairs in the area. During these days, the village transforms—tents, rides, food stalls, and devotional rituals fill the temple grounds.",
          "The final day often includes dramatic demonstrations of faith, such as walking on burning coals and laying on thorn beds, followed by river rituals and Chhau dance performances.",          "The beating of traditional drums, chanting of hymns, and the collective recitation of mantras create an atmosphere of devotion that lingers long after the rituals conclude."
        ],
        bestTimeToVisit: [
          "While devotees come throughout the year, certain times are particularly auspicious: Shravan Mela (July–August): Marked by a festive mood, vibrant rituals, community gatherings, and extended devotional activities.",
          "Other Festivals: Mahashivratri and Chadak Puja bring intense spiritual energy to the site.",
          "Anytime Else: Off-festival seasons offer calm, reflective access for personal prayer and quiet amid nature."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Kera village lies about 10 km from Chakradharpur and is easily reachable by local transport or private vehicles.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "Chakradharpur is the nearest major railhead and is well connected. From there, locals commute to Kera with ease.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "Ranchi Airport is the closest airport, around 180–200 km away, followed by road or rail journey to Chakradharpur.",                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/MaaKeraMandirWestSinghbhum1.jpg",
          "/images/destination/MaaKeraMandirWestSinghbhum2.jpg",
          "/images/destination/MaaKeraMandirWestSinghbhum3.jpg",
          "/images/destination/MaaKeraMandirWestSinghbhum4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/Deori1.webp", alt: "Deori Mandir" },
          { img: "/images/destination/Yogni_sthan1.webp", alt: "Yogini Sthan Godda" },
          { img: "/images/destination/MAAAKARSHINIDEVIMANDIRSARAIKELA1.jpg", alt: "Maa Akarshini Devi Temple, Saraikela" },
          { img: "/images/destination/DALAHIKUNDBOKARO1.jpg", alt: "Dalahi Kund" }
        ]
      },      
      {
        title: "Kaitha Shiv Mandir, Ramgarh",
        description:[
          "Kaitha Shiv Mandir is an ancient Shiva temple located about 3 km from Ramgarh town, along NH-23.",
          "Built around 1670 CE by Maharaja Daler (Dalel) Singh when Ramgarh became the capital of the Ramgarh Raj, the temple showcases an uncommon blend of Bengal, Rajput, and Mughal architectural styles.",
          "Today, it stands in a partly dilapidated state, but its historic significance remains deeply felt.",        ],
        history: [
          "What sets Kaitha apart is that it hosts two Shivlings, one original and one added later (around 2005)—both located on the first floor and brought into worship together.",
          "The main Shivling stands over 12 feet high, under a distinctive five-hooded naga canopy.",
          "Devotees believe that applying holy water from the temple to the ear can cure ear ailments, a faith-based tradition unique to Kaitha.",
          "The temple stands in a serene spot near Ramgarh Cantonment, surrounded by greenery.",
          "Its setting is enhanced by historical depth rather than scenic landscapes, as it is built over a cave leading to a pond a feature that connects worship with nature and adds to the temple’s sanctuary-like aura.",        ],
        bestTimeToVisit: [
          "Sawan Mondays and Mahashivaratri are the most spiritually charged times, drawing large crowds in devotion.",
          "Other weeks offer a quieter, personal experience ideal for reflection and solitude in a historic setting."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Located just 3 km from Ramgarh, accessible by auto or car via NH-23.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest station is Ramgarh Cantonment Station, roughly 1.9 km away.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport, Ranchi (approximately 50 km), followed by a road trip to Ramgarh.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/KAITHASHIVMANDIRRAMGARH1.jpg",
          "/images/destination/KAITHASHIVMANDIRRAMGARH2.jpg",
          "/images/destination/KAITHASHIVMANDIRRAMGARH3.jpg",
          "/images/destination/KAITHASHIVMANDIRRAMGARH4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/BAGESHWARITEMPLECHARTA1.jpg", alt: "Bageshwari Temple, Balbal" },
          { img: "/images/destination/ChutonathMandirDumka1.jpg", alt: "Chutonath Mandir Dumka" },
          { img: "/images/destination/RinkiniMandirEastSinghbhum1.jpg", alt: "Rankini Mandir" },
          { img: "/images/destination/HanthiKeraEastSinghbhum1.jpg", alt: "Hathi Kheda Temple" }
        ]
      },      
      {
        title: "Maa Akarshini Devi Temple, Saraikela",
        description: [
          "The Maa Akarshini Devi Temple is perched atop a 320-foot hill in Saraikela, becoming a beacon of devotion and tradition across Purbi Singhbhum.",
          "The name Akarshini meaning “she who draws,” is a hint at the temple’s magnetic spiritual pull—drawing devotees from across Jharkhand, neighbouring Odisha, Bihar, and West Bengal to bow in prayer and seek blessings.",        ],
        history: [
          "The most vibrant expression of faith here takes shape during the Aakhan Yatra, held each year on January 15 marking Makar Sankranti and the new year.",
          "Pilgrims ascend the hill barefoot, offering prayers, sindoor, flowers, and sweet rice as offerings.",
          "Married women perform the Shomras ritual, and tribal dancers add cultural depth to the celebrations.",
          "The belief is simple yet powerful: heartfelt devotion offered here doesn't go unheeded.",
          "State leaders and local volunteers rally to support the thousands who gather offering food, organizing power lines, and securing safety on the hilltop.",        
        ],
        bestTimeToVisit: [
          "While devotees come throughout the year, certain times are particularly auspicious: Shravan Mela (July–August): Marked by a festive mood, vibrant rituals, community gatherings, and extended devotional activities.",
          "Other Festivals: Mahashivratri and Chadak Puja bring intense spiritual energy to the site.",
          "Anytime Else: Off-festival seasons offer calm, reflective access for personal prayer and quiet amid nature."
        ],
        howToReach: [
              {
                label: "By Road",
                detail: "Saraikela is well-connected by road to Jamshedpur (about 25 km) and Ranchi (about 130 km). Buses, shared autos, and private vehicles frequently travel on this route. From Saraikela town, the temple hill is a short drive, followed by the ritual barefoot climb.",
                icon: "/images/destination/bus.png"
              },
              {
                label: "By Train",
                detail: "The nearest major railway station is Tatanagar Junction (Jamshedpur), about 30 km away. From there, visitors can hire taxis or board local buses towards Saraikela. Smaller stations like Rajkharsawan also provide nearby access.",
                icon: "/images/destination/train.png"
              },
              {
                label: "By Air",
                detail: "The closest airport is Birsa Munda Airport, Ranchi (around 140 km away). Another practical option is Kolkata Airport for those arriving from farther states, with onward train or road travel to Saraikela.",
                icon: "/images/destination/plane.png"
              }
            ],
        images: [
          "/images/destination/MAAAKARSHINIDEVIMANDIRSARAIKELA1.jpg",
          "/images/destination/MAAAKARSHINIDEVIMANDIRSARAIKELA2.jpg",
          "/images/destination/MAAAKARSHINIDEVIMANDIRSARAIKELA3.jpg",
          "/images/destination/MAAAKARSHINIDEVIMANDIRSARAIKELA4.jpg"
        ],
         nearbyAttractions: [
          { img: "/images/destination/BAGESHWARITEMPLECHARTA1.jpg", alt: "Bageshwari Temple, Balbal" },
          { img: "/images/destination/ChutonathMandirDumka1.jpg", alt: "Chutonath Mandir Dumka" },
          { img: "/images/destination/RinkiniMandirEastSinghbhum1.jpg", alt: "Rankini Mandir" },
          { img: "/images/destination/HanthiKeraEastSinghbhum1.jpg", alt: "Hathi Kheda Temple" }

          ]
      },      
      
    ],
  },
  {
    id: 4,
    image: '/images/destination/Tribal_Tourism.webp',
    title: 'Tribal Tourism',
    desc1: 'Discover the vibrant and diverse tribal communities of Jharkhand, renowned for their rich cultural expressions and centuries-old traditions.',
    desc2: 'Engage deeply with the Santhal, Munda, and Ho tribes, experiencing their captivating music, energetic dance forms, colorful festivals, intricate crafts, and unique lifestyle that beautifully celebrate harmony with nature and honor their ancestral heritage.',
    data: [
      {
        title: "Amadubi",
        description: [
          "Amadubi, a quaint village in Jharkhand's East Singhbhum district, is the last bastion of the Paitkar scroll painting tradition, a 500-year-old storytelling art form practiced exclusively by the Chitrakar community.",
          "Here, visitors can witness the creation of intricate vertical scrolls where narratives of tribal life, Hindu epics like the Ramayana and Mahabharata, and local folklore unfold in vivid sequences painted with natural pigments derived from leaves, stones, and soil.",
          "The Chitrakars, originally Bengali performers who settled here under royal patronage, blend painting with oral storytelling.",
          "Artists like Moni Chitrakar and Vijay Chitrakar sing Bengali folk tales while unrolling the scrolls, using instruments like the Ektara and Dotara to accompany their performances—a ritual that transforms the paintings into living narratives.",
          "Workshops with master artists offer hands-on experiences, teaching visitors to grind pigments (like red from hematite or black from burnt rice) and paint basic motifs on handmade paper or cloth."
        ],
        history: [
          "Paitkar’s origins trace back to King Ramachandra Dhal’s reign in Dhalbhumgarh, who granted land to 22 Chitrakar artists after they adorned his queen’s bedroom with their art.",
          "The community, initially surnamed 'Gayen' for their singing prowess, later adopted 'Chitrakar' (picture-makers).",
          "The art form evolved from palm-leaf manuscripts to cloth and paper scrolls, preserving Santhal tribal traditions and Hindu mythology despite declining patronage.",
          "Today, efforts by Jharcraft and local artists aim to revive this heritage through exhibitions and training programs."
        ],
        bestTimeToVisit: [
          "October–March: Pleasant weather (15–30°C) for outdoor workshops.",
          "Karam Festival (August): Witness scroll paintings depicting tribal rituals.",
          "Avoid monsoons (July–September) due to humidity affecting pigment preparation."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "30 km from Jamshedpur via NH-33; taxis available.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Nearest station is Tatanagar Junctio (35 km).",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport, Ranchi (180 km).",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Ambadubi1.webp",
          "/images/destination/Ambadubi2.webp",
          "/images/destination/Ambadubi3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Ulihatu1.jpg", alt: "Ulihatu" },
          { img: "/images/destination/Sirsi1.jpg", alt: "Sirsi Village" },
          { img: "/images/destination/mccluskieganj1.webp", alt: "Mccluskieganj" },
          { img: "/images/destination/Saraikela1.webp", alt: "Saraikela-Chhau" }
        ]
      },
      {
        title: "Ulihatu",
        description: [
          "Ulihatu, a serene village in Khunti district, Jharkhand, holds immense historical significance as the birthplace of Bhagwan Birsa Munda (15 November 1875), the revered tribal freedom fighter and folk hero of India’s independence movement.",
          "The village is nestled amidst undulating hills and lush forests, offering a glimpse into the life and legacy of Birsa Munda, fondly called *Dharti Aba* (Father of the Earth) by tribal communities.",
          "Visitors can pay homage at the reconstructed mud house where Birsa Munda was born, now a memorial site displaying his personal belongings, photographs, and artifacts from the Ulgulan rebellion (1899–1900).",
          "A short trek leads to Dombari Buru, the hill where Birsa’s uprising turned into a massacre in 1900—the site still echoes with the sacrifices of tribal warriors, marked by a memorial pillar erected by Padmashri Ramdayal Munda.",
          "The nearby weekly haats (markets) showcase vibrant tribal crafts like Sohrai paintings, bamboo products, and traditional jewelry, offering a cultural immersion."
        ],
        history: [
          "Birsa Munda’s life was a testament to resistance against British colonial exploitation and the preservation of tribal identity.",
          "Born into the Munda tribe, he led the Ulgulan (Great Tumult), a rebellion against land grabs, forced labor (beth begari), and religious conversion by missionaries.",
          "His slogan, *Abua raj ete jana, maharani raj tundu jana* ('Our kingdom shall come, the queen’s rule shall end'), ignited a movement across Jharkhand, Bihar, and Odisha.",
          "The British crushed the revolt at Dombari Buru, but Birsa’s legacy led to the *Chotanagpur Tenancy Act (1908)*, safeguarding tribal land rights."
        ],
        bestTimeToVisit: [
          "November–March: Pleasant weather (15–30°C); ideal for treks and festivals.",
          "November 15: Birsa Munda’s birth anniversary, marked by grand tributes and cultural events.",
          "Avoid monsoons (July–September) due to heavy rainfall."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Ulihatu is 40 km from Khunti and 30 km from Murhu. Taxis/buses ply from Ranchi (70 km) via NH-33.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Nearest station: Ranchi Junction (75 km). Hire a taxi for the scenic 2-hour drive.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport, Ranchi (80 km). Direct flights from Delhi, Kolkata, and Mumbai. Taxis available.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Ulihatu2.jpg",
          "/images/destination/Ulihatu1.jpg",
          // "/images/destination/ulihatu3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Sirsi1.jpg", alt: "Sirsi Village" },
          { img: "/images/destination/Ambadubi1.webp", alt: "Amadubi" },
          { img: "/images/destination/mccluskieganj1.webp", alt: "Mccluskieganj" },
          { img: "/images/destination/Saraikela1.webp", alt: "Saraikela-Chhau" }
        ]
      },
      {
        title: "Sirsi Village",
        description: [
          "Sirsi, a picturesque village nestled in the dense forests of Latehar district, Jharkhand, offers a rare glimpse into the untouched beauty of nature and the ancient traditions of the Asur tribe.",
          "Surrounded by towering Sal and Pine forests, the village transforms into a golden paradise at dawn as sunlight filters through the leaves, accompanied by the melodic calls of birds like the Indian Pitta and the soothing rustle of trees.",
          "The village is home to the Asur tribe, one of India’s most unique indigenous communities known for their traditional iron-smelting techniques.",
          "Visitors can witness these age-old metalworking practices, purchase exquisite handmade metal crafts, and participate in vibrant folk dances like the Karma dance during tribal festivals.",
          "Evenings come alive with bonfire gatherings where the Asur people share their ancient folk songs (such as Ohira) and captivating stories under a canopy of stars.",
          "A scenic 8.5 km trek to Netarhat—often called the 'Queen of Chotanagpur'—offers breathtaking sunset views over rolling hills and dense forests.",
          "Travelers can opt for an authentic tribal homestay in traditional mud huts, immersing themselves in the simplicity and warmth of Asur hospitality."
        ],
        history: [
          "The Asur tribe, mentioned in ancient Hindu epics, are believed to be among the earliest iron-smelters in India.",
          "Their name derives from the demon Asura, though they reject this mythological association.",
          "Historically, they were renowned for crafting high-quality iron tools and weapons, a skill passed down through generations.",
          "Despite modernization, the Asurs of Sirsi continue to preserve their cultural identity, language, and crafts, making the village a living museum of tribal heritage."
        ],
        bestTimeToVisit: [
          "October to March: Cool weather (12–28°C), ideal for forest walks and outdoor activities.",
          "Karma Festival (August–September): Experience vibrant tribal dances and rituals.",
          "Avoid monsoon (July–September) due to heavy rainfall and slippery trails."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Sirsi is 80 km from Latehar and 150 km from Ranchi. Regular buses and taxis are available from Ranchi via NH-39.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Nearest railway station: Latehar (80 km away). From here, hire a taxi or take a local bus to Sirsi.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport, Ranchi (155 km away). Taxis can be hired for a 4-hour scenic drive through forests and hills.",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Sirsi1.jpg",
          // "/images/destination/sirsi2.webp",
          // "/images/destination/sirsi3.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Ulihatu1.jpg", alt: "Ulihatu" },
          { img: "/images/destination/Ambadubi1.webp", alt: "Amadubi" },
          { img: "/images/destination/mccluskieganj1.webp", alt: "Mccluskieganj" },
          { img: "/images/destination/Saraikela1.webp", alt: "Saraikela-Chhau" }
        ]
      },

      {
        title: "Mccluskieganj",
        description: [
          "Mccluskieganj, nestled 65 km northwest of Ranchi in Jharkhand, is a hauntingly beautiful relic of a failed Anglo-Indian utopia.",
          "Founded in 1933 by Ernest Timothy McCluskie as a 'Mooluk' (homeland) for Anglo-Indians, this hill station—once dubbed 'Mini London'—now stands as a poignant blend of decaying colonial bungalows, tribal villages, and misty forests.",
          "Visitors can wander through weather-beaten 1930s mansions like Roden Hall and The Lodge, their arched windows and sloping roofs whispering tales of ballroom dances and hunting parties long past.",
          "The St. John’s Church and Anglo-Indian cemetery, though crumbling, retain echoes of the community’s vibrant history.",
          "Nearby, the Degadegi River (a Damodar tributary) offers serene picnic spots, its banks frosted over in winter (December–January), when temperatures occasionally dip below freezing.",
          "For nature lovers, a hike through sal forests leads to the seasonal Jhunjhunia Falls, cascading fiercely post-monsoon (July–September).",
          "The region’s microclimate creates surreal winter mornings (January–February) when rooftops and fields glitter with frost 'like powdered sugar'."
        ],
        history: [
          "McCluskieganj’s dream began in 1933 when McCluskie, an Anglo-Indian businessman, purchased 10,000 acres from the Raja of Ratu to create a self-sufficient community.",
          "At its peak, 400 Anglo-Indian families lived here, building bungalows, churches, and bakeries.",
          "However, isolation, lack of economic opportunities, and post-Independence migration to Western countries led to its decline.",
          "By the 1970s, only 30 families remained; today, fewer than 10 Anglo-Indian households linger, their stories preserved in Konkona Sen Sharma’s film *A Death in the Gunj* (2016)."
        ],
        bestTimeToVisit: [
          "October–March: Ideal for exploring with pleasant temperatures (10–25°C) and frosty winter mornings.",
          "July–September: Best for witnessing Jhunjhunia Falls in full flow.",
          "Avoid April–June (heatwaves up to 40°C)."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Well-connected via NH-39 from Ranchi (65 km, 2-hour drive).",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Mccluskieganj Railway Station (limited connectivity) or Ranchi Junction (65 km).",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport, Ranchi (70 km).",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/mccluskieganj1.webp",
          "/images/destination/mccluskieganj2.webp",
          "/images/destination/mccluskieganj3.webp",
          "/images/destination/mccluskieganj5.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Ulihatu1.jpg", alt: "Ulihatu" },
          { img: "/images/destination/Sirsi1.jpg", alt: "Sirsi Village" },
          { img: "/images/destination/Ambadubi1.webp", alt: "Amadubi" },
          { img: "/images/destination/Saraikela1.webp", alt: "Saraikela-Chhau" }
        ]
      },
      {
        title: "Saraikela-Chhau",
        description: [
          "Saraikela, a small town in Jharkhand's East Singhbhum district, is the birthplace of the world-renowned Chhau dance, a UNESCO-recognized intangible cultural heritage.",
          "This mesmerizing tribal martial dance combines vigorous movements, rhythmic footwork, and vibrant masks depicting gods, demons, and animals.",
          "The dance, traditionally performed during the Chaitra Parva festival (March-April), narrates stories from Hindu epics and tribal folklore through its dramatic sequences.",
          "Visitors can witness live Chhau performances at the Seraikella Chhau Dance Centre and explore local workshops where artisans craft the iconic masks using clay, papier-mâché, and natural colors.",
          "The town also serves as a gateway to the Dalma Wildlife Sanctuary, home to elephants, barking deer, and leopards.",
          "A hike to the sanctuary's 3,000-ft summit rewards trekkers with breathtaking sunrise views over the Chotanagpur Plateau.",
          "For history enthusiasts, the Seraikella Palace Museum houses rare artifacts, tribal weapons, and relics showcasing the evolution of Chhau dance under royal patronage.",
          "The museum's collection includes century-old masks, costumes, and instruments used in traditional performances."
        ],
        history: [
          "Chhau dance originated in the 18th century under the patronage of the Saraikela royal family.",
          "The dance form evolved from martial arts practices and tribal rituals, incorporating elements of Odissi and Mayurbhanj Chhau styles.",
          "The kings of Saraikela formalized the art, establishing strict training regimens for performers.",
          "Today, despite modernization, the dance remains deeply rooted in local culture, with annual competitions held to preserve its authenticity."
        ],
        bestTimeToVisit: [
          "March–April: During Chaitra Parva festival for grand Chhau performances.",
          "October–February: Pleasant weather (15–28°C) for wildlife safaris and trekking.",
          "Avoid monsoon season (June–September) when trails become slippery."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Well-connected to Jamshedpur (30 km) and Ranchi (140 km) via NH-33.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: ": Nearest station is Sini Junction (15 km away).",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport, Ranchi (170 km).",
            icon: "/images/destination/plane.png"
          }
        ],
        images: [
          "/images/destination/Saraikela1.webp",
          "/images/destination/Saraikela2.webp"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Ulihatu1.jpg", alt: "Ulihatu" },
          { img: "/images/destination/Sirsi1.jpg", alt: "Sirsi Village" },
          { img: "/images/destination/Ambadubi1.webp", alt: "Amadubi" },
          { img: "/images/destination/mccluskieganj1.webp", alt: "Mccluskieganj" }
        ]
      }
    ],
  },
  {
    id: 5,
    image: '/images/destination/Waterbodies.png',
    title: 'Water Bodies',
    desc1: 'Jharkhand is home to serene lakes, dams, and reservoirs that offer stunning natural views and peaceful getaways.',
    desc2: 'These waterbodies are perfect for picnics, photography, and leisure escapes. Blending calm waters with lush landscapes, they invite travelers to unwind and experience Jharkhand’s refreshing side of nature..',
    data: [
      {
        title: "Bada Talab",
        description: [
          "Bada Talab, often called Ranchi Lake or Bada Talab, lies quietly at the base of Ranchi Hill in central Ranchi. It covers over fifty acres and reflects the changing skyline of the city. The lake was created in 1842 under the supervision of Colonel Onsely, who worked with prisoners to dig it. The purpose was practical: to help recharge the city’s groundwater and supply water to a growing township. Over time, this reservoir became more than that it turned into a part of Ranchi’s daily life.",
          "Over the years, the lake has seen the city expand around it. What started as a simple water body now holds memories of colonial-era calm mornings, festive evenings, and everyday chatter on its banks. Despite challenges like pollution, encroachment, and neglect, Bada Talab remains a familiar landmark that ties Ranchi’s local history to its present."
        ],
        history: [
          "What makes Bada Talab important is how deeply it is woven into community life. People here don’t just pass by it they live with it. On many evenings, you’ll find locals seated at the ghats, children splashing water, and friends walking along the edges. This isn’t just leisure. It's a shared habit, a unifying cultural rhythm.",
          "Bada Talab also becomes a spiritual centre during festivals. During Chhath Puja, for instance, the lake gathers crowds of families offering prayers to the setting sun, lamps flickering on the water, and voices softly chanting. For just a few days, the lake shifts from a place of calm to a living stage of devotion. And yet, the devotion is quiet, without showiness.",
          "In another way, the lake has become a backdrop for memories. Older residents still talk about strolls from decades ago, while younger people come here for weekend walks or to break from their routines. Some say poets and writers have found inspiration by the water’s edge. It’s not a museum or a monument, but this everyday connection gives the lake its lasting cultural value."
        ],
        bestTimeToVisit: [
          "Winter, from around November to February, is the calmest season. Mornings are cool, evenings are soft, and the air feels fresh. It’s the perfect time to take a slow walk or just sit and think.",
          "Summer afternoons can be warm, but the lake remains a comfortable retreat during early mornings and twilight hours. The air cools just enough for evening walks to feel peaceful.",
          "Monsoon brings the countryside alive. The surrounding area turns greener, and the hills reflect on the lake’s surface. The water level rises, and rain patterns give the place a quiet energy. Heavy rain, however, might limit time outdoors.",
          "When culture meets nature, Chhath Puja is the most special moment to visit. For a sense of local tradition and community spirit, nothing beats this time."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Bada Talab sits in central Ranchi, close to major local roads. Whether you’re walking, taking an auto, or riding a bike, you can reach it within a short ride from places like Upper Bazaar or Ranchi Railway Station. Evening traffic means longer travel, but the journey is usually smooth.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Rail",
            detail: "Ranchi Junction is a simple 10-minute drive from the lake. Hatia station serves another access point within 20 minutes. Taxis and auto-rickshaws are easy to find, offering unhurried rides to the lake’s edge.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport is about 10 kilometres away. Flights connect Ranchi with cities like Delhi, Kolkata, Patna, and Mumbai. From the airport, taxis and ride-hailing services drop passengers at the lake in twenty to thirty minutes, depending on traffic.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2789.83993321703!2d85.31529917387843!3d23.367983153352746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f4e10393e4c401%3A0xb82d4b7bcb46e86!2sRanchi%20Lake!5e1!3m2!1sen!2sin!4v1756552146329!5m2!1sen!2sin" 
  width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" 
  referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Bada_Talab1.jpg",
          "/images/destination/Waterbodies/Bada_Talab2.jpg",
          "/images/destination/Waterbodies/Bada_Talab3.jpg",
          "/images/destination/Waterbodies/Bada_Talab4.jpg"
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Tamasin_Waterfall1.jpg", alt: "Tamasin Waterfall" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" },
          { img: "/images/destination/Waterbodies/Lawapani_Waterfall1.jpg", alt: "Lawapani Waterfall" },
          { img: "/images/destination/Waterbodies/Topchanchi_Lake1.jpg", alt: "Topchanchi Lake" }
        ]
      },
      {
        title: "Tamasin Waterfall",
        description: [
          "Tamasin Waterfall sits in the Tulbul area of Chatra district, nestled between two forested hills. The name Tamasin, drawn from local language, means 'darkness prevails'—a nod to how the dense forest canopy often dims the light, even during the day. The waterfall is a striking sight: water cascades more than 30 feet down layered rock, forming a series of small cascades before flowing into a deep pool below.",
          "Local folklore speaks of an ancient hermitage of Rishi Matang on these hills, along with a cave that once housed a shrine to Tamaseen Devi believed to be a powerful hill deity connected with fertility and protection. Over time, the waterfall turned into a beloved spot for villagers, eventually drawing in tourists especially during New Year and festival seasons. Its beauty, combined with spiritual heritage, makes Tamasin both a natural wonder and a place of quiet reverence."
        ],
        history: [
          "Tamasin Waterfall stands out for its raw natural allure. The waterfall splits across rocky surfaces, creating multiple streams, each shimmering against light-burnished stone. The water’s steady murmur resonates in the valley, calming even the busiest thoughts.",
          "Surrounding the falls is a stretch of thick mixed forest that shrouds the area in shades of green and grey, lending the site a mood that is both mysterious and peaceful. It is this blend of rock, forest, and water that gives Tamasin its unique appeal visitors often describe the setting as a gentle escape from noise, with nature’s rhythm inviting reflection and calm.",
          "While people come for the views, they stay for the feel. The forest whispers around the waterfall, punctuated by the calls of monkeys or birds, and the stone steps nearby help you walk closer, but always with a mindful pause. The site’s simplicity, without grand architecture, makes it a rich, unfiltered natural experience."
        ],
        bestTimeToVisit: [
          "The best time to visit Tamasin Waterfall is from March to May and again from August to November. Summer (March to May) brings low water levels but clearer access trails and warm days perfect for mild exploration.",
          "Monsoon (August to November) transforms the waterfall into a powerful curtain of water, renewing the forest’s vibrancy but caution is needed due to slippery ground and stronger currents.",
          "New Year and festival periods see a surge in visitors. In these times, people gather here for the scenic appeal and local traditions. While it can bring life and energy to the site, it may also create crowding and safety concerns.",
          "Authorities have tried to manage safety marking dangerous zones with red ribbons and some barricading to warn visitors about hidden hazards. These precautions are necessary, as accidents, especially during selfie-taking or bathing near steep rock edges, have been reported in the past."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Tamasin is located about 32 kilometres northeast of Chatra town, the district headquarters. The preferred route runs along Chatra–Unta–Kanhachatti–Tulbul Road, then extends toward the falls. The final stretch is a fair-weather trail, often unpaved, better tackled with care. From Hazaribagh, the waterfall is about 65 kilometres away, following all-weather roads up to Itkhori, then branching off toward Tulbul and onward to the falls.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Rail",
            detail: "The closest railway station is Katkamsandi, around 40 kilometres from the site. From there, travelers can hire local transport. Some reports also mention Tori Station on the Chandwa route as an option for connection, though it is slightly further.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airport is in Ranchi, approximately 162 kilometres away. Visitors typically fly in, then travel by road head to Chatra or directly through Kanhachatti and Tulbul to reach the falls.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2768.9881408686874!2d85.09611257391488!3d24.3400673658862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f34f50f577f2b9%3A0x62951f5b1c7af298!2sTamasin%20Waterfall!5e1!3m2!1sen!2sin!4v1756552205527!5m2!1sen!2sin" 
  width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" 
  referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Tamasin_Waterfall1.jpg",
          "/images/destination/Waterbodies/Tamasin_Waterfall2.jpg",
          "/images/destination/Waterbodies/Tamasin_Waterfall3.jpg",
          "/images/destination/Waterbodies/Tamasin_Waterfall4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Bada_Talab1.jpg", alt: "Bada Talab" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" },
          { img: "/images/destination/Waterbodies/Lawapani_Waterfall1.jpg", alt: "Lawapani Waterfall" },
          { img: "/images/destination/Waterbodies/Topchanchi_Lake1.jpg", alt: "Topchanchi Lake" }
        ]
      },
      {
        title: "Panchet Dam",
        description: [
          "Panchet Dam, one of the most significant multipurpose dams in eastern India, stands as a remarkable landmark of Jharkhand. Constructed across the Damodar River near Panchet in Dhanbad district, this colossal structure is not only an engineering marvel but also a site of scenic beauty that attracts visitors throughout the year. Completed in 1959 as part of the Damodar Valley Corporation (DVC) projects, the dam has played a crucial role in flood control, irrigation, power generation, and regional development. With its vast water reservoir stretching far into the horizon, the dam has gradually evolved from being just a technical utility to becoming a hub of natural beauty, weekend getaways, and cultural connections.",
          "The area surrounding Panchet Dam is enveloped by the hills of the Chota Nagpur Plateau, giving it an enchanting backdrop. The large expanse of calm water against the rugged terrain and green forested slopes makes it a perfect destination for those seeking both relaxation and exploration. The dam is also close to historic and religious sites, which allows visitors to combine leisure with cultural experiences. For locals, Panchet Dam is not only a symbol of modern progress but also a favourite picnic spot where families, friends, and tourists gather to enjoy the fresh air, picturesque views, and serene environment.",
          "What makes Panchet Dam unique is the way it blends human achievement with natural charm. While its construction represented a significant leap in India’s post-independence infrastructural development, the reservoir it created has gradually become a habitat for various species of fish and birds, giving the place an ecological character as well. For photographers, the wide landscape, especially during sunrise and sunset, provides breathtaking frames, while for history lovers, the story of its creation connects back to India’s nation-building efforts in the 1950s. All of these make Panchet Dam much more than just a utility structure—it is a destination where history, nature, and community life intersect."
        ],
        history: [
          "The most striking aspect of Panchet Dam lies in its natural significance. Built on the Damodar River, the dam has given rise to a massive reservoir, often described as one of the largest artificial lakes in Jharkhand. This water body stretches for several kilometres, resembling an inland sea and creating a habitat for aquatic life as well as migratory birds during certain seasons. The serene blue expanse framed by undulating hills offers a captivating view, especially in the winter months when the atmosphere is clear, and the sky takes on brilliant colours.",
          "The surrounding landscape of the Chota Nagpur Plateau adds to its natural charm. The hilly terrain, covered with patches of forest and open rocky stretches, contrasts beautifully with the calm reservoir. In monsoon, when the water level rises and the spillway gates are opened, the sight of water gushing out with immense force is both dramatic and awe-inspiring, attracting many tourists. For those who love peaceful natural settings, the winter mornings at Panchet, with mist rising above the water surface, are particularly enchanting.",
          "The dam’s reservoir also plays a role in regional ecology. Over the years, it has become a stopover for birds, adding an element of biodiversity. Anglers and fishing enthusiasts often visit the area, making it a mix of recreational and ecological interest. Unlike a crowded tourist site, Panchet Dam offers a quiet environment where one can sit by the waterside, listen to the soft lapping of waves, and experience the calmness that nature provides."
        ],
        bestTimeToVisit: [
          "The best time to visit Panchet Dam is from October to March, during the winter and early spring months. The weather is pleasant, skies are clear, and the natural beauty of the place can be enjoyed at its fullest.",
          "Monsoon (July to September) is also attractive if you wish to see the dam in action when the gates open, but travel during heavy rains can be challenging.",
          "Summer is generally avoided due to high temperatures."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Panchet Dam is well connected by road from Dhanbad city, which lies about 54 km away. Regular buses, shared autos, and private taxis are available. The approach road winds through picturesque landscapes, making the journey pleasant.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Panchet Railway Station, just 2 km from the dam, but it is a small stop with limited train connectivity. For better access, visitors can reach Dhanbad Junction, a major railhead.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The closest airport is Kazi Nazrul Islam Airport, Durgapur (about 90 km away), which offers flights to major Indian cities. The Birsa Munda Airport, Ranchi (around 200 km) is another option with broader connectivity. From either airport, taxis or buses can be hired to reach Panchet Dam.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2783.1919817384946!2d86.74506757389001!3d23.68198219140233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f6e62cb0ffffff%3A0xf501cdff173dbd27!2sPanchet%20Dam!5e1!3m2!1sen!2sin!4v1756552249186!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Panchet_Dam1.jpg",
          "/images/destination/Waterbodies/Panchet_Dam2.jpg",
          "/images/destination/Waterbodies/Panchet_Dam3.jpg",
          "/images/destination/Waterbodies/Panchet_Dam4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Bada_Talab1.jpg", alt: "Bada Talab" },
          { img: "/images/destination/Waterbodies/Tamasin_Waterfall1.jpg", alt: "Tamasin Waterfall" },
          { img: "/images/destination/Waterbodies/Lawapani_Waterfall1.jpg", alt: "Lawapani Waterfall" },
          { img: "/images/destination/Waterbodies/Topchanchi_Lake1.jpg", alt: "Topchanchi Lake" }
        ]
      },
      {
        title: "Dimna Lake",
        description: [
          "Dimna Lake is a scenic artificial reservoir located near Jamshedpur in Jharkhand. Surrounded by gently rolling hills and greenery, the lake provides a peaceful retreat from the city’s hustle. Constructed primarily as a water reservoir to meet Jamshedpur’s drinking water needs, Dimna Lake has also become a popular spot for relaxation, picnics, and nature walks. The lake’s calm waters, often reflecting the surrounding hills, create a serene setting that attracts families, photographers, and nature enthusiasts.",
          "The lake is bordered by well-maintained pathways, small gardens, and open spaces where visitors can enjoy leisure activities. Its location amidst natural hills makes it particularly scenic during sunrise and sunset, when the water surface mirrors the sky in soft hues. Beyond its functional role as a reservoir, Dimna Lake serves as a community space, fostering recreational activities and offering a glimpse of the natural beauty of the Jamshedpur region. Local fishermen also use parts of the lake, adding a touch of traditional rural life to the area."
        ],
        history: [
          "Dimna Lake’s main significance is natural. It provides a habitat for a variety of birds, fish, and other aquatic life, making it a small but important ecosystem near an urban area. The surrounding hills and vegetation help maintain a balanced environment and contribute to the area’s scenic beauty. Bird watchers and photography enthusiasts often visit to capture migratory birds, kingfishers, and other species that frequent the lake.",
          "The lake also plays a role in local climate moderation, providing cooler air and open space in contrast to the industrial city of Jamshedpur. Its combination of water, greenery, and hills makes it a valuable recreational and environmental asset for both residents and visitors."
        ],
        bestTimeToVisit: [
          "The ideal time to visit Dimna Lake is from October to March, when the weather is pleasant with cool mornings and comfortable afternoons. This season is best for enjoying boat rides, walking along the lake, and photographing the natural surroundings.",
          "Summer months can be hot and humid, while monsoon rains may make paths slippery and increase the water level, limiting certain activities."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Dimna Lake is located about 12 kilometres from Jamshedpur city centre. Local buses, taxis, and auto-rickshaws provide convenient transport for visitors traveling from the city or nearby towns.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Tatanagar Junction, approximately 15 kilometres away, connecting Jamshedpur to major cities like Kolkata, Ranchi, and Bhubaneswar. From the station, taxis or local transport can be used to reach the lake.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The closest airport is Sonari Airport in Jamshedpur, around 12 kilometres from the lake. Private taxis or buses are the preferred mode of transport from the airport to Dimna Lake.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d22402.924511964604!2d86.24061948346397!3d22.862514618862285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f60a02060f7f4d%3A0xef76b9652cfe115e!2sDimna%20Lake!5e1!3m2!1sen!2sin!4v1756552298260!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/DIMNALAKESARAIKELA1.jpg",
          "/images/destination/Waterbodies/DIMNALAKESARAIKELA2.jpg",
          "/images/destination/Waterbodies/DIMNALAKESARAIKELA3.jpg",
          "/images/destination/Waterbodies/DIMNALAKESARAIKELA4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Bada_Talab1.jpg", alt: "Bada Talab" },
          { img: "/images/destination/Waterbodies/Topchanchi_Lake1.jpg", alt: "Topchanchi Lake" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" },
          { img: "/images/destination/Waterbodies/Lawapani_Waterfall1.jpg", alt: "Lawapani Waterfall" }
        ]
      },
      {
        title: "Panchghagh Fall",
        description: [
          "Panchghagh Fall is one of the most picturesque waterfalls in Jharkhand, located in Khunti district. The site is named “Panchghagh,” which means five streams, as the river splits into five distinct cascades over the rocky terrain before joining again at the base. Surrounded by dense forests, small hills, and agricultural lands, the falls create a serene and refreshing environment. The journey to Panchghagh passes through rural landscapes, tribal villages, and stretches of open fields, giving visitors a chance to witness local life and natural beauty. The area around the falls is calm and peaceful, offering a perfect escape from urban chaos and a spot for picnics, nature walks, and short treks.",
          "The falls are not just a natural spectacle; they are a place where visitors can feel connected to the rhythm of the river, the chirping of birds, and the rustling of trees. The cool water, coupled with the surrounding greenery, creates a soothing atmosphere that attracts both local tourists and nature enthusiasts from nearby towns. Panchghagh Fall, while relatively unknown compared to larger waterfalls in India, is treasured for its tranquil setting and the ability to enjoy nature in its raw and unspoiled form."
        ],
        history: [
          "The natural beauty of Panchghagh Fall is its most prominent feature. The waterfall is part of the Sankh River system, and its five separate streams cascading over uneven rocks form a scenic panorama. During the monsoon, the water flow increases, creating a spectacular sight, while in the dry season, the falls appear gentler, revealing the structure of the rocks and natural pools below.",
          "The surrounding forests host a variety of flora and fauna. Sal, mahua, and bamboo trees are common, while birds and small mammals are frequently spotted. The area’s biodiversity adds to the charm of the falls, making it an appealing location for eco-tourists and photographers. The calm environment also provides opportunities for meditation, yoga, and other wellness activities in nature. The sound of cascading water, combined with the fresh air and green surroundings, makes Panchghagh Fall a rejuvenating spot for visitors of all ages."
        ],
        bestTimeToVisit: [
          "The ideal time to visit Panchghagh Fall is between October and March. The weather during these months is pleasant, with moderate temperatures that make walking and exploring around the falls comfortable.",
          "The post-monsoon months are particularly beautiful, as the river is full and the surroundings are lush, providing excellent photo opportunities.",
          "Monsoon season should be avoided due to slippery paths and strong water currents, which can make visiting unsafe.",
          "Summers can be hot, reducing the comfort of extended visits."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Panchghagh Fall is about 40 kilometres from Khunti, the district headquarters. The route passes through rural roads and villages, and taxis or private vehicles are recommended for ease of travel.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Hatia, approximately 50 kilometres away. From the station, visitors can hire taxis or shared vehicles to reach the falls.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The closest airport is Birsa Munda Airport in Ranchi, around 60 kilometres from Panchghagh Fall. From the airport, visitors can travel by road via Ranchi to reach Khunti and then continue to the falls.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2798.6548761703502!2d85.25403297386306!3d22.945382619207102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f53fedb5d4a017%3A0x4e615c498516ce45!2sPanchghagh%20Falls!5e1!3m2!1sen!2sin!4v1756552337325!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Panchghag_Fall1.jpg",
          "/images/destination/Waterbodies/Panchghag_Fall2.jpg",
          "/images/destination/Waterbodies/Panchghag_Fall3.jpg",
          "/images/destination/Waterbodies/Panchghag_Fall4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Dassam_Falls1.jpg", alt: "Dassam Fall" },
          { img: "/images/destination/Waterbodies/Tamasin_Waterfall1.jpg", alt: "Tamasin Waterfall" },
          { img: "/images/destination/Waterbodies/Topchanchi_Lake1.jpg", alt: "Topchanchi Lake" },
          { img: "/images/destination/Waterbodies/Bada_Talab1.jpg", alt: "Bada Talab" }
        ]
      },
      {
        title: "Dassam Fall",
        description: [
          "Dassam Falls is one of the most captivating waterfalls near Ranchi, formed by the Kanchi River cascading from a height of around 98 feet. Surrounded by forested hills and rocky cliffs, the falls create a dramatic yet peaceful landscape, making it a favoured destination for nature lovers, photographers, and day-long retreats."
        ],
        history: [
          "Dassam Falls, though not historically constructed, is naturally formed by the Kanchi River, a tributary of the Subarnarekha. It is a horsetail-type waterfall that retains ecological and cultural significance. Local communities respect it as a calming natural feature, inspiring folklore, seasonal rituals, and local stories about river deities."
        ],
        bestTimeToVisit: [
          "October to March is the best time to visit Dassam Falls. The post-monsoon and winter months provide strong but safe water flow, ideal for sightseeing and photography. Summers can be hot, while the monsoon months make the rocky trails slippery and dangerous."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Dassam Falls is about 40 km from Ranchi city. The drive passes through forested areas and villages. Private vehicles or taxis are the most convenient option.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Ranchi Junction, around 40 km from the falls. Taxis and local transport are available from the station.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airport is Birsa Munda Airport, Ranchi, about 45 km away. Visitors can hire taxis or rental vehicles to reach Dassam Falls.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          "<iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2794.4838444256025!2d85.46464537387033!3d23.146256411704005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f5056e67b9e4a3%3A0x25570e4d2a5836ee!2sDassam%20Falls!5e1!3m2!1sen!2sin!4v1756552380924!5m2!1sen!2sin\" width=\"600\" height=\"450\" style=\"border:0;\" allowfullscreen=\"\" loading=\"lazy\" referrerpolicy=\"no-referrer-when-downgrade\"></iframe>"],
        images: [
          "/images/destination/Waterbodies/Dassam_Falls1.jpg",
          "/images/destination/Waterbodies/Dassam_Falls2.jpg",
          "/images/destination/Waterbodies/Dassam_Falls3.jpg",
          "/images/destination/Waterbodies/Dassam_Falls4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Bada_Talab1.jpg", alt: "Bada Talab" },
          { img: "/images/destination/Waterbodies/Tamasin_Waterfall1.jpg", alt: "Tamasin Waterfall" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" },
          { img: "/images/destination/Waterbodies/Topchanchi_Lake1.jpg", alt: "Topchanchi Lake" }
        ]
      },
      {
        title: "Ladhna Dam",
        description: [
          "Ladhna Dam, located in Jamtara district, is a serene getaway surrounded by green hills, forests, and calm waters. Known for its natural charm and scenic landscape, it is a popular picnic spot for families, friends, and travelers who wish to escape into nature. The tranquil waters and panoramic beauty make it an ideal destination for relaxation and photography."
        ],
        history: [
          "Constructed as a water reservoir, Ladhna Dam serves the purpose of irrigation and water conservation for nearby villages. Over the years, it has become a cultural and social hub where locals gather for leisure. While not ancient, its significance lies in supporting agriculture and creating a natural retreat for the community."
        ],
        bestTimeToVisit: [
          "The best time to visit Ladhna Dam is from October to March when the weather is cool and pleasant. Monsoon months enhance the beauty with lush greenery and a full water body, though heavy rains may restrict access."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Ladhna Dam is about 15 km from Jamtara town. Local transport, taxis, and private vehicles are easily available.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is Jamtara Railway Station, around 18 km from the dam. From the station, local transport options like auto-rickshaws and taxis are available.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airport is Kazi Nazrul Islam Airport in Durgapur, West Bengal, about 100 km away. Netaji Subhas Chandra Bose International Airport, Kolkata, is another option, approximately 220 km from Jamtara.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          "<iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29240.8784732034!2d86.74343789661918!3d23.96060479176973!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f6c96b2d8fdb2f%3A0xf00b8b6d8696f734!2sLadhna%20Dam!5e1!3m2!1sen!2sin!4v1756703913450!5m2!1sen!2sin\" width=\"600\" height=\"450\" style=\"border:0;\" allowfullscreen=\"\" loading=\"lazy\" referrerpolicy=\"no-referrer-when-downgrade\"></iframe>"
        ],
        images: [
          "/images/destination/Waterbodies/Ladhna_Dam1.jpg",
          "/images/destination/Waterbodies/Ladhna_Dam2.jpg",
          "/images/destination/Waterbodies/Ladhna_Dam3.jpg",
          "/images/destination/Waterbodies/Ladhna_Dam4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" },
          { img: "/images/destination/Waterbodies/Sundar_Dam1.jpg", alt: "Sundar Dam" },
          { img: "/images/destination/Waterbodies/Palna_Dam1.jpg", alt: "Palna Dam" },
          { img: "/images/destination/Waterbodies/Kelaghagh_Dam1.jpg", alt: "Kelaghagh Dam" }
        ]
      },
      {
        title: "Rani Fall",
        description: [
          "Rani Falls, located about 20 kilometers from Khunti district headquarters on the Tajna River, is a scenic waterfall. It is known for its gently flowing river and sandy banks, which make it a safe and popular picnic spot. The surrounding lush forests further enhance its natural beauty."
        ],
        history: [
          "This waterfall is not only a natural attraction but also holds importance for the local tribal community. The surrounding forests are covered with sal and other native tree species, providing shelter to various kinds of wildlife. The area is gaining popularity among nature lovers and adventure tourism enthusiasts."
        ],
        bestTimeToVisit: [
          "Monsoon (July–September): The waterfall flows with full force, making it the most attractive time.",
          "Winter (October–February): Pleasant weather, ideal for picnics and trekking.",
          "Summer (March–June): Morning and evening are the best times to visit."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Located about 20 km from Khunti, it can be easily reached by taxi or private vehicle.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is in Ranchi, about 45 km away.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airport is in Ranchi, from where the falls can be reached via Khunti by road.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2797.1119317646253!2d85.3775057738657!3d23.019882816431338!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f513dc92a9ceb3%3A0xc4f03b7b28fee30d!2sRani%20Fall!5e1!3m2!1sen!2sin!4v1756552506812!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination//Waterbodies/Rani_Fall1.jpg",
          "/images/destination//Waterbodies/Rani_Fall2.jpg",
          "/images/destination//Waterbodies/Rani_Fall3.jpg",
          "/images/destination//Waterbodies/Rani_Fall4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Baghmunda_Fall1.jpg", alt: "Baghmunda Waterfall" },
          { img: "/images/destination/Waterbodies/Satbahini_Waterfall1.jpg", alt: "Satbahini Waterfall" },
          { img: "/images/destination/Waterbodies/Panchghag_Fall1.jpg", alt: "Panchghagh Fall" },
          { img: "/images/destination/Waterbodies/Lawapani_Waterfall1.jpg", alt: "Lawapani Waterfall" }
        ]
      },
      {
        title: "Baghmunda Waterfall",
        description: [
          "Nestled in Basia block of Gumla district, Baghmunda Waterfall is a quietly fascinating destination. What sets it apart is the point where the Koel River splits into three streams as it cascades over rocky formations. These streams converge and plunge onto a boulder shaped like a tiger’s head—hence the name “Baghmunda.”"
        ],
        history: [
          "At the base of the falls sits a small, centuries-old Shiva shrine—a quiet reminder of local faith and tradition. Many travelers stop here during New Year celebrations to offer prayers for prosperity and peace. This blend of natural beauty and spiritual presence adds depth to the site’s allure."
        ],
        bestTimeToVisit: [
          "Towards the New Year: The atmosphere comes alive as families and locals gather for celebrations near the falls.",
          "Post-monsoon (October–February): Clean water flow, lush surroundings, and stable terrain—optimal for photography and safe enjoyment.",
          "Avoid peak monsoon: Rugged paths and slippery rocks increase risk during heavy rains."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Around 48 km from Gumla district HQ and approximately 100 km from Ranchi, the waterfall is accessible via the Ranchi–Simdega route. Buses and private vehicles make the trip, followed by a short walk or drive from Basia to the falls.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest major rail connection is in Ranchi, offering access to Gumla via road.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport in Ranchi serves as the closest air hub, with onward road travel to Gumla.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          ""
        ],
        images: [
          "/images/destination/Waterbodies/Baghmunda_Fall1.jpg",
          "/images/destination/Waterbodies/Baghmunda_Fall2.jpg",
          "/images/destination/Waterbodies/Baghmunda_Fall3.jpg",
          "/images/destination/Waterbodies/Baghmunda_Fall4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Rani_Fall1.jpg", alt: "Rani Fall" },
          { img: "/images/destination/Waterbodies/Satbahini_Waterfall1.jpg", alt: "Satbahini Waterfall" },
          { img: "/images/destination/Waterbodies/Dassam_Falls1.jpg", alt: "Dassam Fall" },
          { img: "/images/destination/Waterbodies/Tamasin_Waterfall1.jpg", alt: "Tamasin Waterfall" }
        ]
      },
      {
        title: "Sundar Dam",
        description: [
          "Sundar Dam, located at Rajabhitta in Pathargama block of Godda district, is an important irrigation project and tourist destination. Surrounded by hilly forests and small hills encircled with water, it has become a scenic and peaceful place."
        ],
        history: [
          "This dam is not only one of the largest irrigation projects in Godda district but is also becoming a major recreation and picnic spot. Facilities like adventure activities, boating, children’s park, guest house, and decorative lighting are being added, creating tourism as well as employment opportunities for local people."
        ],
        bestTimeToVisit: [
          "Winter (December–February): Pleasant weather, best time to enjoy picnics and natural beauty.",
          "Monsoon (July–September): Greenery and a full reservoir make the scenery enchanting, but visit with caution.",
          "Holiday Season: Great time to travel with family and friends for relaxation."
        ],
        howToReach: [
          {
            label: "By Train",
            detail: "The nearest railway station is Godda Junction, about 18 km away.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Road",
            detail: "Sundar Dam can be easily reached from Godda city via Pathargama. It is connected to NH-133.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Air",
            detail: "The nearest airports are in Dumka or Ranchi, from where Godda can be reached by road.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2754.824326157578!2d87.32796327393973!3d24.980064340464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f06520c63aa6af%3A0xef1b864fd27ada4a!2sSundar%20Dam%20Lahathi!5e1!3m2!1sen!2sin!4v1756552566667!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Sundar_Dam1.jpg",
          "/images/destination/Waterbodies/Sundar_Dam2.jpg",
          "/images/destination/Waterbodies/Sundar_Dam3.jpg",
          "/images/destination/Waterbodies/Sundar_Dam4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Ladhna_Dam1.jpg", alt: "Ladhna Dam" },
          { img: "/images/destination/Waterbodies/Palna_Dam1.jpg", alt: "Palna Dam" },
          { img: "/images/destination/Waterbodies/Kelaghagh_Dam1.jpg", alt: "Kelaghagh Dam" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" }
        ]
      },
      {
        title: "Basant Rai Pond",
        description: [
          "Basant Rai Pond, located in Pathargama block of Godda district, is a vast and historic reservoir spread over about 50 acres of land. It was built by King Basant Rai, the ruler of ancient Basantarai, who wanted to make it a grand religious centre. Today, this pond is a famous site due to its deep historical significance, religious beliefs, and mysterious legends.",
          "This pond is not only a water source but also a centre of faith for the local people. It is believed to be a sacred site of Goddess Bhagwati, where devotees bathe and offer prayers for their wishes. Every year, starting from Chaitra Sankranti (around April 14), the Bishu Mela (Bishua Mela) is organized here for 15 days, attracting thousands of devotees and tourists."
        ],
        history: [
          "The pond stands as a symbol of devotion and cultural heritage, carrying forward the vision of King Basant Rai. For centuries, it has been revered as a religious site where rituals and fairs connect communities.",
          "During Bishu Mela, the area transforms into a spiritual and cultural hub. Pilgrims arrive from nearby districts and states, making it a living space of tradition and shared belief.",
          "Apart from its religious significance, the pond has preserved local legends and stories. Elders often recall the grandeur of past fairs, while newer generations continue the tradition with equal enthusiasm."
        ],
        bestTimeToVisit: [
          "Chaitra Sankranti (April): The best time to visit is during the Bishu Mela, when the place is filled with religious enthusiasm and cultural activities.",
          "Winter (November–February): Pleasant weather makes it ideal for walking around the pond and participating in religious rituals.",
          "Monsoon (July–September): Greenery increases, crowds are fewer, making it suitable for a peaceful experience."
        ],
        howToReach: [
          {
            label: "By Train",
            detail: "The nearest railway station is Godda Junction, about 25 km away. From there, the pond can be reached by road.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Road",
            detail: "Basantarai village can be easily reached from Godda city via Pathargama. NH-133 and local roads are well connected.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Air",
            detail: "The nearest airports are in Dumka or Ranchi, from where the pond can be reached via Godda by road.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2754.4757468878092!2d87.19675027394028!3d24.995621339838603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f05d0a15f27c15%3A0xf932940f1fdf7189!2sBasantarai%20pond!5e1!3m2!1sen!2sin!4v1756552615751!5m2!1sen!2sin" 
    width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Basant_Rai_Pond1.jpg",
          "/images/destination/Waterbodies/Basant_Rai_Pond2.jpg",
          "/images/destination/Waterbodies/Basant_Rai_Pond3.jpg",
          "/images/destination/Waterbodies/Basant_Rai_Pond4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Bada_Talab1.jpg", alt: "Bada Talab" },
          { img: "/images/destination/Waterbodies/Tamasin_Waterfall1.jpg", alt: "Tamasin Waterfall" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" },
          { img: "/images/destination/Waterbodies/Topchanchi_Lake1.jpg", alt: "Topchanchi Lake" }
        ]
      },
      {
        title: "Satbahini Waterfall",
        description: [
          "Satbahini Waterfall is a striking natural gem in Kandi block, Garhwa district. Its name 'Satbahini' reflects its unique beauty: seven separate streams leap together over the rocks, forming a unified cascade that’s both visually captivating and soothing to the soul.",
          "The waterfall blends adventurous terrain with spiritual significance, making it a favoured destination for nature lovers, pilgrims, and photographers alike. Across seasons, the adjacent temples and prayer areas make it a place where devotion and scenic wonder converge."
        ],
        history: [
          "Satbahini has long been regarded as a sacred natural site. Devotees visit throughout the year, considering the seven streams as divine symbols of purity.",
          "Local legends speak of its spiritual power, where saints and villagers performed rituals for blessings. Over time, it became both a pilgrimage centre and a natural retreat.",
          "Its layered cascades and green surroundings have preserved the charm of a timeless landscape, while nearby temples continue to host prayers and offerings."
        ],
        bestTimeToVisit: [
          "Throughout the year: The waterfall is lively and inviting in all seasons.",
          "New Year and Makar Sankranti: Visitor numbers peak—many come from nearby states to celebrate and enjoy the environment.",
          "Post-monsoon and winter months: Clear water flows and fresher surroundings make it ideal for nature walks, photos, and peaceful visits."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "The waterfall is about 40 km from Garhwa town, accessible via a smooth and well-maintained road. Buses and private vehicles frequently serve the route.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest station is Mohammadganj Railway Station, approximately 7 km away. From there, local vehicles handle the short onward trip.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Ranchi is the nearest airport, roughly 200 km away. Visitors typically proceed by road or rail to reach Satbahini.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d88533.4588685751!2d83.66003736249999!3d24.4458616!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398c3ce28b9c24eb%3A0x2963f5f145b3a675!2sShree%20Satbahini%20Jharna!5e1!3m2!1sen!2sin!4v1756552673962!5m2!1sen!2sin" 
    width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Satbahini_Waterfall1.jpg",
          "/images/destination/Waterbodies/Satbahini_Waterfall2.jpg",
          "/images/destination/Waterbodies/Satbahini_Waterfall3.jpg",
          "/images/destination/Waterbodies/Satbahini_Waterfall4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Baghmunda_Fall1.jpg", alt: "Baghmunda Waterfall" },
          { img: "/images/destination/Waterbodies/Rani_Fall1.jpg", alt: "Rani Fall" },
          { img: "/images/destination/Waterbodies/Panchghag_Fall1.jpg", alt: "Panchghagh Fall" },
          { img: "/images/destination/Waterbodies/Lawapani_Waterfall1.jpg", alt: "Lawapani Waterfall" }
        ]
      },
      {
        title: "Topchanchi Lake",
        description: [
          "Topchanchi Lake is an artificial reservoir nestled along NH-2 (Golden Quadrilateral) in Dhanbad district. Created in 1924 by damming streams, it spans around 214 acres. Today, it provides water to Dhanbad and nearby areas and is surrounded by green hills and forests that make it a serene picnic spot.",
          "Its proximity to the Topchanchi Wildlife Sanctuary, a compact yet rich ecosystem, adds to its natural charm. The lake is not just a water source; its surroundings host dry peninsular sal forests and a mix of wildlife ranging from deer and wild boars to a wide array of migratory birds. Once a celebrated film location, the lake was featured in Hindi and Bengali films with legends like Uttam Kumar, Ashok Kumar, and Dharmendra."
        ],
        history: [
          "Topchanchi Lake was created in 1924 to store water by damming natural streams. Over time, it became both a lifeline and a cultural symbol for Dhanbad and nearby regions.",
          "The reservoir has supported communities with drinking water while also offering a scenic retreat. Its iconic litchi garden, gazebos, and walkways have become part of local heritage.",
          "During earlier decades, the lake’s natural beauty attracted filmmakers, giving it recognition in both Hindi and Bengali cinema. It still remains one of Dhanbad’s most cherished landmarks."
        ],
        bestTimeToVisit: [
          "Winters (December–February): Ideal for peaceful picnics, birdwatching, and enjoying fresh air.",
          "Monsoon (July–September): Water levels rise, making it visually vibrant—but visit with caution.",
          "New Year/Winter holiday season: Nostalgic and scenic, great for guest-house stays if available."
        ],
        howToReach: [
          {
            label: "By Train",
            detail: "The nearest station is at Gomoh, just about 6 km away, linked to the historic Netaji Subhas Chandra Bose heritage line.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Road",
            detail: "Topchanchi Lake is roughly 37 km from Dhanbad Station via NH-2, accessible by car or local transport.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Air",
            detail: "Nearest airports are Ranchi and Kolkata. From there, one can continue by rail or road to Dhanbad and then to Topchanchi.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5556.058566151577!2d86.17748173690288!3d23.92314792137666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f4035b9e86c1af%3A0x9df45b5468ab0cff!2sTopchanchi%20Lake!5e1!3m2!1sen!2sin!4v1756552717745!5m2!1sen!2sin" 
    width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Topchanchi_Lake1.jpg",
          "/images/destination/Waterbodies/Topchanchi_Lake2.jpg",
          "/images/destination/Waterbodies/Topchanchi_Lake3.jpg",
          "/images/destination/Waterbodies/Topchanchi_Lake4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Bada_Talab1.jpg", alt: "Bada Talab" },
          { img: "/images/destination/Waterbodies/Tamasin_Waterfall1.jpg", alt: "Tamasin Waterfall" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" },
          { img: "/images/destination/Waterbodies/Lawapani_Waterfall1.jpg", alt: "Lawapani Waterfall" }
        ]

      },
      {
        title: "Palna Dam",
        description: [
          "Nestled in the beautiful landscapes of the Seraikela Kharsawan district, near the well-known town of Chandil, Palna Dam is one of those places where nature and tranquillity meet. Surrounded by green hills, open skies, and the calm expanse of water, this destination is a perfect getaway for anyone seeking peace, natural beauty, and a breath of fresh air.",
          "Although not as widely known as Chandil Dam, Palna Dam holds its own charm. Its serene setting makes it ideal for quiet picnics, nature walks, photography, and simple moments of relaxation by the water."
        ],
        history: [
          "Palna Dam has quietly developed into a popular local retreat for families and travellers alike. Though overshadowed by the larger Chandil Dam, it has retained its identity as a peaceful escape.",
          "For locals, the dam serves as a weekend gathering place where traditions of family picnics and nature walks continue.",
          "Over the years, it has also drawn interest from travellers seeking offbeat destinations, giving it recognition as one of Jharkhand’s lesser-known but treasured spots."
        ],
        bestTimeToVisit: [
          "Post-monsoon and winter months (October–February): Reservoir is full, surroundings are lush, and weather is cool and pleasant.",
          "Mornings and evenings during this period are particularly beautiful, with soft light and breezes.",
          "Summer: Afternoons can be warm, but early mornings and evenings are still pleasant."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "From Jamshedpur, Chandil is about 37 km away, taking roughly 1 hour by car. From Chandil, Palna Dam can be reached within a short 8–10 km drive through scenic countryside.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "Chandil Junction is the nearest railway station, with regular trains from Jamshedpur, Ranchi, and Kolkata. From there, autorickshaws and taxis connect to Palna Dam.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airport is Birsa Munda Airport, Ranchi (around 110 km). From there, buses and taxis are available via Chandil.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2798.648043829471!2d85.9328055738631!3d22.945713019194812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f5eaabd7739fdd%3A0xac010f0b2750851b!2sPalna%20Dam%2C%20Palna%2C%20Jharkhand%20832404!5e1!3m2!1sen!2sin!4v1756552773161!5m2!1sen!2sin" 
    width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Palna_Dam1.jpg",
          "/images/destination/Waterbodies/Palna_Dam2.jpg",
          "/images/destination/Waterbodies/Palna_Dam3.jpg",
          "/images/destination/Waterbodies/Palna_Dam4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Ladhna_Dam1.jpg", alt: "Ladhna Dam" },
          { img: "/images/destination/Waterbodies/Sundar_Dam1.jpg", alt: "Sundar Dam" },
          { img: "/images/destination/Waterbodies/Kelaghagh_Dam1.jpg", alt: "Kelaghagh Dam" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" }
        ]
      },
      {
        title: "Kelaghagh Dam",
        description: [
          "Kelaghagh Dam, located about 4 km from Simdega district headquarters on the Chinda River, is a picturesque dam surrounded by hills. It offers a scenic view to tourists and serves as the lifeline of the district. It is also the main source of drinking water supply for Simdega town, managed by the Simdega Notified Area Committee.",
          "The dam plays a crucial role in maintaining ecological balance in the Simdega region. The surrounding hills and greenery provide a natural habitat where different bird species and small wildlife can be spotted. For the local community, the dam is not just a water source but also a popular picnic spot. The charm of Kelaghagh Dam is unique—the calm waters, surrounding hills, and greenery captivate visitors. A small, beautiful park has been built on a plateau near the dam, offering panoramic views of the reservoir. The reflection of the hills in the water adds to its beauty."
        ],
        history: [
          "Kelaghagh Dam is not only an engineering achievement but also a lifeline for Simdega district. Over time, it has become both a water resource and a cultural hub where families gather for picnics and boating.",
          "The dam has preserved ecological harmony in the area by supporting local biodiversity, while also serving as the main source of drinking water for Simdega town.",
          "With its natural beauty and role as a community centre, Kelaghagh continues to be a landmark where nature and daily life intersect."
        ],
        bestTimeToVisit: [
          "Winter (October–February): Pleasant weather, ideal for picnics and boating.",
          "Monsoon (July–September): The dam is filled to the brim, and the landscape is at its most vibrant.",
          "Summer (March–June): Best to visit in the morning and evening."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Only 3 km from Simdega town, easily accessible by auto or taxi.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Train",
            detail: "The nearest railway station is at Rourkela (Odisha), about 70 km away.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "The nearest airport is in Ranchi, about 150 km away. From there, taxis or buses can take you to Simdega.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2805.8940760751693!2d84.51754957385049!3d22.59273963223463!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398a9c3d43510551%3A0xde9137458e9fa261!2sKelaghat%20Dm%20Rd%2C%20Jharkhand%20835223!5e1!3m2!1sen!2sin!4v1756552807123!5m2!1sen!2sin" 
    width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Kelaghagh_Dam1.jpg",
          "/images/destination/Waterbodies/Kelaghagh_Dam2.jpg",
          "/images/destination/Waterbodies/Kelaghagh_Dam3.jpg",
          "/images/destination/Waterbodies/Kelaghagh_Dam4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Ladhna_Dam1.jpg", alt: "Ladhna Dam" },
          { img: "/images/destination/Waterbodies/Sundar_Dam1.jpg", alt: "Sundar Dam" },
          { img: "/images/destination/Waterbodies/Palna_Dam1.jpg", alt: "Palna Dam" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" }
        ]
      },
      {
        title: "Lawapani Waterfall",
        description: [
          "Lawapani Waterfall, nestled in Madanpur village of Peshrar block, Lohardaga district, is quietly earning the title of one of Jharkhand’s most mesmerizing natural retreats. Its signature beauty lies in a cascading flow that falls not in a single plunge but in twelve distinct steps, stretching gracefully from east to west. Each tier ranges between 10 to 80 feet, averaging around 30 feet in height, creating a layered spectacle of water dancing over the rocks.",
          "It stands surrounded by dense forests and rolling hills, giving visitors a serene escape from the everyday. Beyond its aesthetic appeal, Lawapani is a living symbol of transformation—once in a region known for unrest, it now invites peace, picnic vibes, and a reconnection with nature’s wonder."
        ],
        history: [
          "Lawapani Waterfall is deeply tied to the natural and cultural revival of the Lohardaga region. Once overshadowed by unrest, it has emerged as a beacon of peace and tourism.",
          "Local traditions and stories consider the twelve cascading steps as symbolic, each tier reflecting harmony with nature and life’s journey.",
          "Today, it attracts not only picnickers and adventurers but also those seeking calm, with its layered beauty continuing to inspire awe and community pride."
        ],
        bestTimeToVisit: [
          "Monsoon (July–August): The waterfall is at its fullest, showing its dramatic face.",
          "Post-Monsoon/Winter (November–February): Water remains steady, weather is ideal, and picnicking is most comfortable.",
          "Visiting after sunset or alone is discouraged—better to go in groups, during daylight, and carry your essentials."
        ],
        howToReach: [
          {
            label: "By Road",
            detail: "Lawapani Waterfall lies about 38–52 km from Lohardaga town, depending on route. The drive via Kekerang and Peshrar takes you through forested hills, offering a scenic lead-up. A private vehicle is the most practical way to go.",
            icon: "/images/destination/bus.png"
          },
          {
            label: "By Rail",
            detail: "The nearest railway station is Lohardaga, roughly 34 km away, with frequent local transport from there.",
            icon: "/images/destination/train.png"
          },
          {
            label: "By Air",
            detail: "Birsa Munda Airport in Ranchi is the closest airport, about 103–115 km away followed by road travel to reach the waterfall.",
            icon: "/images/destination/plane.png"
          }
        ],
        map: [
          `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2784.99512290714!2d84.54302507388685!3d23.597204894643077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398b15b133c7b737%3A0x1fe650f92fd69333!2sLawapani%20waterfall!5e1!3m2!1sen!2sin!4v1756552956275!5m2!1sen!2sin" 
    width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"></iframe>`
        ],
        images: [
          "/images/destination/Waterbodies/Lawapani_Waterfall1.jpg",
          "/images/destination/Waterbodies/Lawapani_Waterfall2.jpg",
          "/images/destination/Waterbodies/Lawapani_Waterfall3.jpg",
          "/images/destination/Waterbodies/Lawapani_Waterfall4.jpg",
        ],
        nearbyAttractions: [
          { img: "/images/destination/Waterbodies/Bada_Talab1.jpg", alt: "Bada Talab" },
          { img: "/images/destination/Waterbodies/Tamasin_Waterfall1.jpg", alt: "Tamasin Waterfall" },
          { img: "/images/destination/Waterbodies/Panchet_Dam1.jpg", alt: "Panchet Dam" },
          { img: "/images/destination/Waterbodies/Topchanchi_Lake1.jpg", alt: "Topchanchi Lake" }
        ]
      },
    ],
  }
];
